import { PlantImages } from "../types";

export const images: PlantImages = {
  1: {
    gardenImages: [],
    googleImages: [
      {
        image: "https://pfaf.org/Admin/PlantImages/AgapanthusAfricanus.jpg",
        imageLink:
          "https://pfaf.org/user/Plant.aspx?LatinName=Agapanthus%20africanus",
      },
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/91lBiyKfHQL._SX466_.jpg",
        imageLink:
          "https://www.amazon.com/Agapanthus-Africanus-Lily-Nile-Groundcover/dp/B07FMDPRLC",
      },
      {
        image: "https://pfaf.org/Admin/PlantImages/AgapanthusAfricanus2.jpg",
        imageLink:
          "https://pfaf.org/user/Plant.aspx?LatinName=Agapanthus%20africanus",
      },
      {
        image:
          "https://cdn2.bigcommerce.com/server4900/4f8a6/products/267/images/548/Agapanthus_africanus_A._orientalis_Blue_Lily_of_the_Nile__42315.1368464062.300.300.jpg?c=2",
        imageLink:
          "http://www.plantclearance.com/agapanthus-africanus-a-orientalis-blue-lily-of-the-nile-5-gallon/",
      },
    ],
  },
  2: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://staging-claire-austin-hardy-plants.s3.amazonaws.com/products/4001/product/persicaria-affinis-darjeeling_red.jpg?1488563040",
        imageLink:
          "https://www.claireaustin-hardyplants.co.uk/products/persicaria-affinis-darjeeling-red",
      },
      {
        image:
          "https://ontheedgegardening.files.wordpress.com/2011/07/july-2011-143.jpg",
        imageLink:
          "https://ontheedgegardening.wordpress.com/2011/07/20/persicaria-affinis-darjeeling-red-himalayan-knotweed/",
      },
      {
        image: "https://www.bomen.be/images/gardenpack/peadred.jpg",
        imageLink:
          "https://www.bomen.be/nl/zoekresultaten/PEADRED-persicaria-aff-darjeeling-red.html",
      },
      {
        image:
          "https://www.penlanperennials.co.uk/wp-content/uploads/2015/12/Persicaria-affinis-Darjeeling-Red1.jpg",
        imageLink:
          "https://www.penlanperennials.co.uk/plant/shade-and-woodland-plants/persicaria-affinis-darjeeling-red/",
      },
    ],
  },
  3: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.worldwondersgardens.co.uk/image/cache/catalog/Product%20Images/Garden%20Flower%20Seeds/campsis-radicans-flava-002-650x650.jpg",
        imageLink:
          "http://www.worldwondersgardens.co.uk/campsis-radicans-flava-30-seeds-yellow-trumpet-vine-trumpet-creeper",
      },
      {
        image:
          "https://media-cdn.tripadvisor.com/media/photo-s/13/d4/13/7e/campsis-radicans-flava.jpg",
        imageLink:
          "https://www.tripadvisor.com/LocationPhotoDirectLink-g1809056-d670512-i332665726-Judith_Queree_s_Garden-St_Ouen_Jersey_Channel_Islands.html",
      },
      {
        image:
          "http://d3d71ba2asa5oz.cloudfront.net/12001418/images/campsis_r_flava1.jpg?refresh",
        imageLink:
          "https://hirts.com/yellow-trumpet-vine-plant-campsis-radicans-flava-2-5-pot/",
      },
      {
        image:
          "https://www.bambooplants.ca/wp-content/uploads/2018/05/Campsis-radicans-Flava-flower.jpg",
        imageLink:
          "https://www.bambooplants.ca/product/yellow-trumpet-vine-campsis-flava-canada/",
      },
    ],
  },
  4: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://cdn.shopify.com/s/files/1/2858/6430/products/Little_Ruby_Fig_Tree_620x.png?v=1547561306",
        imageLink:
          "https://sowexotic.com/products/little-ruby-fig-ficus-carica",
      },
      {
        image:
          "https://previews.123rf.com/images/hheellggaa/hheellggaa1709/hheellggaa170900076/87246084-branch-of-a-fig-tree-ficus-carica-with-leaves-and-fruits.jpg",
        imageLink:
          "https://www.123rf.com/photo_87246084_branch-of-a-fig-tree-ficus-carica-with-leaves-and-fruits.html",
      },
      {
        image:
          "http://cdn.shoplightspeed.com/shops/601459/files/8618961/ficus-carica-brown-turkey-fig-brown-turkey-1.jpg",
        imageLink:
          "http://www.behmerwald.com/ficus-carica-brown-turkey-fig-brown-turkey-5.html",
      },
    ],
  },
  5: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://paramountnursery.ca/wp-content/uploads/2019/04/hidcote.jpg",
        imageLink:
          "https://paramountnursery.ca/product/lavandula-angustifolia-hidcote-blue-lavender/",
      },
      {
        image: "https://cdn.woolmans.com/product-images/op/z/LAV-068z.jpg",
        imageLink:
          "https://www.woolmans.com/Flower-Plants_2/Perennials_4/Lavender-Hidcote_4.html",
      },
      {
        image:
          "http://kalliergeia.com/wp-content/uploads/2018/03/5.-Lavandula-angustifolia-Hidcote-1.jpg",
        imageLink:
          "https://www.kalliergeia.com/en/lavandula-angustifolia-hidcote/",
      },
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/00/00/00/40/pl0000004047.jpg?width=940&height=940",
        imageLink:
          "https://www.crocus.co.uk/plants/_/lavandula-angustifolia-hidcote/classid.4047/",
      },
    ],
  },
  6: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "http://sadko.by/wp-content/uploads/2016/06/Ophiopogon-z-250x300.jpg",
        imageLink:
          "http://sadko.by/shop/ophiopogon-planiscapus-niger-ofiopogon-ploskostrelyj-niger/",
      },
      {
        image:
          "https://www.willaert.be/websites/1/uploads/image/PRODUCTIMAGES/OPHIOPOGON_PLANISCAPUS_'NIGER'.jpg",
        imageLink:
          "https://www.willaert.be/nl/plant/OPHIOPOGON+PLANISCAPUS+'NIGER'/oppniger",
      },
      {
        image:
          "http://roudeophuis.nl/media/com_hikashop/upload/ophiopogon%20plan.%20'Niger'.jpg",
        imageLink:
          "http://roudeophuis.nl/grassen/product/66-ophiopogon-plan-niger",
      },
      {
        image:
          "http://shop.windyridgegardencentre.ie/images/products/Herbaceous/Ophiopogon%20plan.%20Nigrescens.jpg",
        imageLink:
          "http://shop.windyridgegardencentre.ie/en/baskets-c-1/summer-planters-and-hanging-baskets-c-20537/ophiopogon-plan-nigrescens-p-10203",
      },
    ],
  },
  7: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Anemone_x_hybrida_Honorine_Jobert_4_nbrcg_wi_1024x1024.jpg?v=1450124628",
        imageLink:
          "https://www.ballyrobertgardens.com/products/anemone-x-hybrida-honorine-jobert",
      },
      {
        image: "https://wimastergardener.org/files/2016/03/AnemoneHJ-plant.jpg",
        imageLink:
          "https://wimastergardener.org/article/anemone-honorine-jobert/",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Anemone_x_hybrida_Honorine_Jobert_3_nbrcg_wi_1024x1024.jpg?v=1450124612",
        imageLink:
          "https://www.ballyrobertgardens.com/products/anemone-x-hybrida-honorine-jobert",
      },
      {
        image:
          "https://www.florablom.com/media/catalog/product/cache/4/image/9df78eab33525d08d6e5fb8d27136e95/1/4/1435255716anemone_honorine_jobert_wikimedia_1/japanese-anemone-honorine-jobert-(anemone-hybrida).jpg",
        imageLink:
          "https://www.florablom.com/en/japanese-anemone-honorine-jobert-anemone-hybrida/",
      },
    ],
  },
  8: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://plantright.org/wp-content/uploads/2017/05/Trachelospermum-jasminoides_Photo-by-Flickr-user-Herry-Lawford-1300x975.jpg",
        imageLink:
          "https://plantright.org/better-plants/trachelospermum-jasminoides/",
      },
      {
        image:
          "https://www.villagenurseries.com/wp-content/uploads/2015/08/Trachelospermum-jasminoides.jpg",
        imageLink:
          "https://www.villagenurseries.com/product/trachelospermum-jasminoides-star-jasmine/",
      },
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/20/00/03/08/pl2000030876_card4_lg.jpg",
        imageLink:
          "https://www.waitrosegarden.com/plants/_/trachelospermum-jasminoides/classid.2000030876/",
      },
      {
        image:
          "https://www.hedgesdirect.co.uk/acatalog/Star-Jasmine-(Trachelospermum-Jasminoides)-Flowers.jpg",
        imageLink:
          "https://www.hedgesdirect.co.uk/acatalog/star-jasmine-trachelospermum-jasminoides.html",
      },
    ],
  },
  9: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.knollgardens.co.uk/app/uploads/2018/10/Ophiopogon-Minor7243.jpg",
        imageLink:
          "https://www.knollgardens.co.uk/product/ophiopogon-japonicus-minor/",
      },
      {
        image: "https://www.vasteplant.be/catalog/picts/OPMINO.JPG",
        imageLink:
          "https://www.vasteplant.be/catalog/index.cfm?fuseaction=DETAIL&TREFNAAM=OPMINO",
      },
      {
        image:
          "https://dkpo4ygqb6rh6.cloudfront.net/APPELTERN_NL/imageresized/89466/215d368a53bc4b28b660e539638a1fb5/388_517_90_fixedjpg/ophiopogon_japonicus_minor_-_slangenbaard.jpg",
        imageLink:
          "https://appeltern.nl/nl/tuinadvies/plantenencyclopedie/ophiopogon_japonicus_minor_-_slangenbaard",
      },
      {
        image:
          "https://www.shootgardening.co.uk/uploaded/images//plants/plant_24886/thumb_180_plant_24886_shoot_20180227205606.jpg",
        imageLink:
          "https://www.shootgardening.co.uk/plant/ophiopogon-japonicus-minor",
      },
    ],
  },
  10: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.dearplants.com/wp-content/uploads/2018/02/Festuca-glauca-Blue-fescue-Summer-color.jpg",
        imageLink:
          "https://www.dearplants.com/shop/grasses/festuca-glauca-blue-fescue/",
      },
      {
        image: "https://i.ebayimg.com/images/g/~G0AAOxyTMdTOMWb/s-l300.jpg",
        imageLink:
          "https://www.ebay.com/itm/Festuca-Glauca-Blue-Grass-150-Seeds-/182239372200",
      },
      {
        image:
          "https://cdn.nexternal.com/romence/images/WG-grass_Festuca_g._ElijahBlue-main3.jpg",
        imageLink:
          "https://shop.romencegardens.com/festuca-glauca-elijah-blue-p17.aspx",
      },
      {
        image:
          "https://d6p0gevo8s9lm.cloudfront.net/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/f/e/festuca-glauca-blue750x750.jpg",
        imageLink:
          "https://www.gardeningexpress.co.uk/deal800915-festuca-glauca-elijah-blue-fescue-pack-of-five",
      },
    ],
  },
  11: {
    gardenImages: [],
    googleImages: [
      {
        image: "https://pfaf.org/Admin/PlantImages/TeucriumChamaedrys.jpg",
        imageLink:
          "https://pfaf.org/user/Plant.aspx?LatinName=Teucrium+chamaedrys",
      },
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/6115qQzdhqL._SX425_.jpg",
        imageLink:
          "https://www.amazon.com/P088S-Creeping-Germander-Teucrium-Chamaedrys/dp/B0757D4KLW",
      },
      {
        image:
          "https://www.morningsunherbfarm.com/wp-content/uploads/2013/07/image-1.jpg",
        imageLink:
          "https://www.morningsunherbfarm.com/product/teucrium-chamaedrys-nana-dwarf-wall-germander/",
      },
      {
        image:
          "https://www.researchgate.net/profile/Ibrahim_Mehmeti/publication/318275166/figure/fig1/AS:531158360223744@1503649429459/Teucrium-chamaedrys-L-growing-wild-in-Kosovo-Photo-taken-from-Arben-Haziri.png",
        imageLink:
          "https://www.researchgate.net/figure/Teucrium-chamaedrys-L-growing-wild-in-Kosovo-Photo-taken-from-Arben-Haziri_fig1_318275166",
      },
    ],
  },
  12: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://images.homedepot-static.com/productImages/06e5dd79-3e38-4ee8-b483-05f8c4dbd450/svn/van-zyverden-flower-bulbs-83536-64_1000.jpg",
        imageLink:
          "https://www.homedepot.com/p/Van-Zyverden-Crocosmia-Lucifer-Bulbs-25-Set-83536/304117557",
      },
      {
        image:
          "https://www.edenbrothers.com/store/media/Bulbs-Flowers/resized/CKWH%20108-0145-1_medium.jpg",
        imageLink:
          "https://www.edenbrothers.com/store/crocosmia-bulbs-lucifer.html",
      },
      {
        image:
          "https://www.highcountrygardens.com/media/catalog/product/c/r/crocosmia_lucifer_walters_gardens_cropped.jpg?width=700&height=700&canvas=700:700&quality=80&bg-color=255,255,255&fit=bounds",
        imageLink:
          "https://www.highcountrygardens.com/flower-bulbs/unique-spring-planted-bulbs/lucifer-crocosmia",
      },
      {
        image:
          "https://www.gardenia.net/rendition.slider_detail/uploads/plant_family/1478540928-aeb6abcc43dafed04/Crocosmia-Lucifer.jpg",
        imageLink:
          "https://www.gardenia.net/plant-variety/crocosmia-montbretia",
      },
    ],
  },
  13: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "http://www.perennials.com/watermark.php?path=perennials/1-305-180.jpg&watermark=images/watermark_heritage.png&xpos=.88&ypos=.95",
        imageLink:
          "http://www.perennials.com/plants/lamium-maculatum-pink-pewter.html",
      },
      {
        image:
          "https://www.smgrowers.com/imagedb/Lamium_maculatumPinkPewter.jpg",
        imageLink:
          "https://www.smgrowers.com/products/plants/plantdisplay.asp?plant_id=3725",
      },
      {
        image:
          "https://dorsetperennials.co.uk/wp-content/uploads/2015/04/Lamium-Pink-Pewter.jpg",
        imageLink:
          "https://dorsetperennials.co.uk/product/lamium-maculatum-pink-pewter/",
      },
      {
        image:
          "https://img.plantis.info/wp-content/uploads/2015/06/Lamiummaculatum.jpg",
        imageLink:
          "https://plantsam.com/lamium-maculatum-pink-chablispink-pewter/",
      },
    ],
  },
  14: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/611ili1110L._SX425_.jpg",
        imageLink:
          "https://www.amazon.com/Nandina-Domestica-Shrub-Heavenly-Healthy/dp/B016CAG90Q",
      },
      {
        image:
          "https://caraghnurseries.ie/wp-content/uploads/2018/03/Nandina-Domestica.jpg",
        imageLink:
          "https://caraghnurseries.ie/product/nandina-domestica-heavenly-bamboo-4lzj/",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1008/4432/products/Heavenly_Bamboo_2.jpg?v=1543343154",
        imageLink:
          "https://underthesunseeds.com/products/heavenly-bamboo-bush-seeds-nandina-domestica-25-seeds",
      },
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/61SnYWqiunL._SX466_.jpg",
        imageLink:
          "https://www.amazon.com/LovelyGarden-NANDINA-DOMESTICA-HEAVENLY-BAMBOO/dp/B07CQVMMD4",
      },
    ],
  },
  15: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.tuincentrumsterk.nl/files/images/webshop/olijfboom-olea-europea-18cm-1519640853-1_l.jpg",
        imageLink:
          "https://www.tuincentrumsterk.nl/product/15044/olijfboom-olea-europea-c50-50-stam",
      },
      {
        image:
          "https://citytree.nl/images/com_hikashop/upload/olijfboom-grillige-stam-1.jpg",
        imageLink:
          "https://citytree.nl/assortiment/bomen-en-planten/olijfbomen/product/olea-europaea-grillig-vertakt-3",
      },
      {
        image:
          "https://s.s-bol.com/imgbase0/imagebase3/large/FC/3/8/9/9/9200000107809983.jpg",
        imageLink:
          "https://www.bol.com/nl/p/oude-olijfboom-met-dikke-stam-190-250-cm-incl-pot/9200000107809983/",
      },
    ],
  },
  16: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/10/00/00/10/pl1000001090.jpg?width=940&height=940",
        imageLink:
          "https://www.crocus.co.uk/plants/_/briza-media/classid.1000001090/",
      },
      {
        image:
          "https://www.anniesannuals.com/signs/b%20-%20c/images/briza_media_02.jpg",
        imageLink: "https://www.anniesannuals.com/plants/view/?id=149",
      },
      {
        image:
          "https://www.coblands.co.uk/userfiles/product_image/.main/ecomproducts-image-48.jpg",
        imageLink: "https://www.coblands.co.uk/products/17-briza-media-2l",
      },
      {
        image: "https://www.ecgrowers.com/v/vspfiles/photos/91031-2.jpg",
        imageLink: "https://www.ecgrowers.com/Briza-p/91031.htm",
      },
    ],
  },
  17: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://dorsetperennials.co.uk/wp-content/uploads/2014/06/Polystichum-setiferum-Congestum-3.jpg",
        imageLink:
          "https://dorsetperennials.co.uk/product/polystichum-setiferum-congestum/",
      },
      {
        image:
          "http://static1.squarespace.com/static/5aad08f67c9327b03154f300/5ba18c064fa51aba30389063/5bd5878d0852291fdf56ae61/1550422412716/?format=1500w",
        imageLink:
          "https://paddockplants.co.uk/ferns/polystichum-setiferum-congestum",
      },
      {
        image:
          "https://dorsetperennials.co.uk/wp-content/uploads/2014/06/Polystichum-setiferum-Congestum-3-400x400.jpg",
        imageLink:
          "https://dorsetperennials.co.uk/product/polystichum-setiferum-congestum/",
      },
      {
        image:
          "http://www.plantilus.com/_Media/jhg_2_-polystichum_setiferu.jpeg",
        imageLink:
          "http://www.plantilus.com/gardens/hillier-gardens-uk/jermyns-house-area/the-tea-room-garden/polystichum-setiferum-conge.html",
      },
    ],
  },
  18: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "http://www.stadibulduri.lv/images/Stadi/graudzales/kinas_miskante_kleine_silberspinne.jpg",
        imageLink:
          "http://www.stadibulduri.lv/index.php/lv-lv/augu-apraksti/item/miscanthus-sinensis-kleine-siberspinne",
      },
      {
        image:
          "https://www.promessedefleurs.com/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/M/i/Miscanthus-sinensis-Kleine-Silberspinne-9445-1.jpg",
        imageLink:
          "https://www.promessedefleurs.com/vivaces/graminees/graminees-par-variete/miscanthus/miscanthus-sinensis-kleine-silberspinne-roseau-de-chine.html",
      },
      {
        image: "https://www.gapphotos.com/images/WebPreview/0423/0423296.jpg",
        imageLink:
          "https://www.gapphotos.com/FeatureContactSheet.asp?featureref=1173",
      },
      {
        image:
          "https://www.promessedefleurs.com/media/catalog/product/cache/1/photo_feuillage/9df78eab33525d08d6e5fb8d27136e95/M/i/Miscanthus-sinensis-Kleine-Silberspinne-9445-FE.jpg",
        imageLink:
          "https://www.promessedefleurs.com/vivaces/graminees/graminees-par-variete/miscanthus/miscanthus-sinensis-kleine-silberspinne-roseau-de-chine.html",
      },
    ],
  },
  19: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Vinca_minor_f._alba_Gertrude_Jekyll_1_nbrcg_wi_2x3_1024x1024.jpg?v=1456514742",
        imageLink:
          "https://www.ballyrobertgardens.com/products/vinca-minor-f-alba-gertrude-jekyll",
      },
      {
        image:
          "https://d6p0gevo8s9lm.cloudfront.net/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/0/B/0B7E47A4658204DBB98BDA08EC825303.jpg",
        imageLink:
          "https://www.gardeningexpress.co.uk/vinca-minor-alba-white-lesser-periwinkle-plants-in-bud-bloom-pack-of-three",
      },
      {
        image:
          "http://overlandnurseries.com.au/wp-content/uploads/vinca-minor-alba-dwarf-periwinkle-groungcover-plant.jpg",
        imageLink:
          "http://overlandnurseries.com.au/product/vinca-minor-alba-dwarf-periwinkle-groungcover-plant/",
      },
      {
        image:
          "https://www.gardenersdream.co.uk/images/vinca-minor-alba-lesser-periwinkle-evergreen-shrub-garden-p440-28604_image.jpg",
        imageLink:
          "https://www.gardenersdream.co.uk/vinca-minor-alba-lesser-periwinkle-evergreen-shrub-garden-p440",
      },
    ],
  },
  20: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.outsidepride.com/images/products/detail/gardenflower/cimicifuga3.jpg",
        imageLink:
          "https://www.outsidepride.com/seed/flower-seed/cimicifuga-seeds-ramosa.html",
      },
      {
        image:
          "http://seedempire.com/images/detailed/1/Bugbane_Seeds_Cimicifuga_Ramosa_Atropurpurea.jpg",
        imageLink:
          "https://seedempire.com/bugbane-cimicifuga-seeds-ramosa-atropurpurea.html",
      },
      {
        image: "https://i.ebayimg.com/images/g/Hr4AAOSwSVdbxEgd/s-l300.jpg",
        imageLink:
          "https://www.ebay.ie/itm/Cimicifuga-ramosa-Atropurpurea-50-seeds-/362459158225",
      },
      {
        image:
          "https://www.jardinjasmin.com/catalogue/userfiles/productlargeimages/product_3244.jpg",
        imageLink:
          "https://www.jardinjasmin.com/catalogue/product.php?ProductID=1730&UILanguage=EN",
      },
    ],
  },
  21: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/51ZGz8hepuL.jpg",
        imageLink:
          "https://www.amazon.com/Pixies-Gardens-Liriope-muscari-Christmas/dp/B07B9XZXWG",
      },
      {
        image: "https://www.pfaf.org/Admin/PlantImages/LiriopeMuscari2.jpg",
        imageLink:
          "https://www.pfaf.org/user/Plant.aspx?LatinName=Liriope+muscari",
      },
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/91F4lXGOgQL._SX425_.jpg",
        imageLink:
          "https://www.amazon.com/LILYTURF-Liriope-Muscari-Monkey-Flower/dp/B01MZ1VN5R",
      },
      {
        image:
          "https://www.gardenia.net/rendition.slider_detail/uploads/plant/1556023326-bf603cb2c15ee482c/shutterstock_1238942206%20Optimized.jpg",
        imageLink:
          "https://www.gardenia.net/plant/liriope-muscari-blue-lily-turf",
      },
    ],
  },
  22: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://springmeadownursery.com/images/made/files/plant_images/Hydrangea%20Limelight%201_1080_1080_60.jpg",
        imageLink:
          "https://springmeadownursery.com/plantfinder/limelight-39190",
      },
      {
        image:
          "https://www.provenwinners.com/sites/provenwinners.com/files/imagecache/500x500/ifa_upload/limelight_hydrangea-2.jpg",
        imageLink:
          "https://www.provenwinners.com/plants/hydrangea/limelight-panicle-hydrangea-hydrangea-paniculata",
      },

      {
        image:
          "http://cdn.shopify.com/s/files/1/0059/8835/2052/products/Limelight-Hydrangea-Tree-450w_grande.jpg?v=1549660503",
        imageLink:
          "https://www.fast-growing-trees.com/products/limelight-hydrangea-tree",
      },
      {
        image:
          "https://s3-us-west-1.amazonaws.com/contentlab.studiod/getty/01ad4873832e4994ba41f53fe4d8cbd5.jpg",
        imageLink:
          "https://homeguides.sfgate.com/cut-back-limelight-hydrangeas-32145.html",
      },
    ],
  },
  23: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://i.pinimg.com/originals/d9/83/aa/d983aa5f1e8a98ce9488ccb5cdabdf7f.jpg",
        imageLink: "https://www.pinterest.com/pin/528891549970514868/",
      },
      {
        image:
          "https://www.moga.eu/images/thumbs/w_1_0007376_macja-meta-grog.jpeg",
        imageLink: "https://www.moga.eu/nepeta-racemosa-grog",
      },
      {
        image:
          "https://i.pinimg.com/originals/d0/d0/19/d0d0199fbca4c622865ad92567a1afe0.jpg",
        imageLink: "https://www.pinterest.ch/pin/528891549970516614/",
      },
      {
        image:
          "http://www.vivaipriola.it/wp-content/themes/x_lapriola/piante/cartimgs/NE30332_big.jpg",
        imageLink: "http://www.vivaipriola.com/nepeta-racemosa-grog/",
      },
    ],
  },
  24: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "http://d3e1m60ptf1oym.cloudfront.net/b54adcf3-dbbc-4d0a-a676-4aaf8f0fe66f/L149910_xlarge.jpg",
        imageLink:
          "http://www.perdereauphotography.com/de/media/b54adcf3-dbbc-4d0a-a676-4aaf8f0fe66f-waldsteinia-ternata",
      },
      {
        image:
          "https://d6p0gevo8s9lm.cloudfront.net/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/9/E/9E964DF9986B89740AD5C8EB217ED78D.jpg",
        imageLink:
          "https://www.gardeningexpress.co.uk/s76134-waldsteinia-ternata-barren-strawberry",
      },
      {
        image:
          "http://www.lubera.co.uk/media/image/thumbnail/2276368_1_720x600.jpg",
        imageLink:
          "http://www.lubera.co.uk/plants/ornamental-shrubs/ground-covers/classic-ground-covers/waldsteinia-ternata-siberian-waldsteinia",
      },
      {
        image:
          "http://d3e1m60ptf1oym.cloudfront.net/e58271d2-abb0-4a55-82db-cee01160254e/L141705_xlarge.jpg",
        imageLink:
          "http://www.perdereauphotography.com/en/media/e58271d2-abb0-4a55-82db-cee01160254e-waldsteinia-ternata-by-a-pond",
      },
    ],
  },
  25: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.jardinjasmin.com/catalogue/userfiles/productlargeimages/1320.jpg",
        imageLink:
          "https://www.jardinjasmin.com/catalogue/product.php?ProductID=1572&UILanguage=EN",
      },
    ],
  },
  26: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://staging-claire-austin-hardy-plants.s3.amazonaws.com/products/3453/product/panicum.jpg?1462296662",
        imageLink:
          "https://www.claireaustin-hardyplants.co.uk/products/panicum-virgatum-rehbraun",
      },
      {
        image: "https://ua.all.biz/img/ua/catalog/7972545.jpeg",
        imageLink:
          "https://ua.all.biz/en/millet-prutyevidny-rekhdraum-panicum-virgatum-g7972545",
      },
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/20/00/01/35/pl2000013573.jpg?width=940&height=940",
        imageLink:
          "https://www.crocus.co.uk/plants/_/panicum-virgatum-rehbraun/classid.2000013573/",
      },
      {
        image:
          "https://d6p0gevo8s9lm.cloudfront.net/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/7/2/722636F2F4BF668A15641BADC0CD49C5.jpg",
        imageLink:
          "https://www.gardeningexpress.co.uk/g10732-panicum-virgatum-rehbraun-switch-grass",
      },
    ],
  },
  27: {
    gardenImages: [],
    googleImages: [
      {
        image: "https://gardeners.s3.amazonaws.com/p/253530_3.jpg",
        imageLink:
          "https://www.dobies.co.uk/Garden/Flowers/Trees-and-Shrubs/Fagus-Sylvatica-Atropurpurea-Potted-Plants_FAGUSSYLV.htm",
      },
      {
        image:
          "https://www.dunnesgardencentre.com/image/cache/catalog/products/large-trees/Fagussylatropurpurea7.5L-500x500.jpg",
        imageLink:
          "https://www.dunnesgardencentre.com/Fagus%20sylvatica%20atropurpurea%207.5L%20180%20cm",
      },

      {
        image:
          "https://spectrees.s3-ap-southeast-2.amazonaws.com/9397-a5e25bb8af/conversions/Fagus_sylvatica_purpurea_2-small.jpg",
        imageLink:
          "https://www.specialitytrees.com.au/trees/fagus-sylvatica-atropurpurea-n8fi3",
      },
      {
        image:
          "https://i.ebayimg.com/00/s/MTIwMFgxNjAw/z/QEsAAOSwDNdVt01Y/$_57.JPG?set_id=880000500F",
        imageLink:
          "https://www.ebay.co.uk/itm/1-Copper-Purple-Beech-Fagus-Sylvatica-Atropurpurea-1-2ft-Tall-In-a-1L-Pot-/231963920488",
      },
    ],
  },
  28: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.faidateingiardino.com/wp-content/uploads/2018/01/camelia-japonica.jpg",
        imageLink:
          "https://www.faidateingiardino.com/piante-da-giardino/camelia-japonica",
      },
      {
        image: "https://pfaf.org/Admin/PlantImages/CamelliaJaponica2.jpg",
        imageLink:
          "https://pfaf.org/user/Plant.aspx?LatinName=Camellia+japonica",
      },
      {
        image:
          "https://media-cdn.tripadvisor.com/media/photo-s/0f/c2/0c/12/camelia-japonica.jpg",
        imageLink:
          "https://www.tripadvisor.in/LocationPhotoDirectLink-g635626-d528348-i264375314-Villa_Carlotta-Tremezzina_Lake_Como_Lombardy.html",
      },
      {
        image:
          "https://www.gardenia.net/rendition.slider_detail/uploads/plant/1440113358-c392849c65bf03702/39342051_m.jpg",
        imageLink:
          "https://www.gardenia.net/plant/Camellia-Japonica-Pink-Perfection",
      },
    ],
  },
  29: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "http://pepiniere-roche-saint-louis.fr/89-large_default/carex-morrowii-variegata-.jpg",
        imageLink:
          "http://pepiniere-roche-saint-louis.fr/en/77-carex-morrowii-variegata-.html",
      },
      {
        image:
          "https://www.thompson-morgan.com/product_images/100/optimised/CARE-T58065-A_h.jpg",
        imageLink:
          "https://www.thompson-morgan.com/p/carex-morrowii-variegata/t58065TM",
      },
      {
        image:
          "http://www.jacksonsnurseries.co.uk/images/detailed/1/Carex-morrowii-Variegata-sub.jpg",
        imageLink:
          "https://www.jacksonsnurseries.co.uk/carex-morrowii-variegata.html",
      },
      {
        image:
          "https://d6p0gevo8s9lm.cloudfront.net/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/E/5/E500297141F2339E1F00AB15B02AEA00.jpg",
        imageLink:
          "https://www.gardeningexpress.co.uk/g10593-carex-morrowii-variegata",
      },
    ],
  },
  30: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/00/00/00/24/pl0000002476.jpg?width=940&height=940",
        imageLink:
          "https://www.rhsplants.co.uk/plants/_/anemone--hybrida-knigin-charlotte/classid.2476/",
      },
      {
        image:
          "https://apps.rhs.org.uk/plantselectorimages/detail/WSY0006853_4330.jpg",
        imageLink:
          "https://www.rhs.org.uk/Plants/112594/Anemone-x-hybrida-Konigin-Charlotte/Details",
      },

      {
        image:
          "https://dorsetperennials.co.uk/wp-content/uploads/2014/09/Anemone-Queen-Charlotte-2.jpg",
        imageLink:
          "https://dorsetperennials.co.uk/product/anemone-x-hybrida-queen-charlotte-anemone-x-hybrida-konigin-charlotte/",
      },
    ],
  },
  31: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.bootendart.co.uk/wp-content/uploads//2016/09/Hypericum-inodorum-White-Gem-Close-up.png",
        imageLink:
          "https://www.bootendart.co.uk/introducties/shrubs/hypericum-white-gem/attachment/hypericum-inodorum-white-gem-close-up-2/",
      },
      {
        image:
          "https://www.bootendart.co.uk/wp-content/uploads//2016/09/Hypericum-inodorum-Green-Gem-Close-up.png",
        imageLink:
          "https://www.bootendart.co.uk/introducties/shrubs/hypericum-green-gem/",
      },
      {
        image:
          "https://www.classicroses.co.uk/media/catalog/product/cache/1/image/443x443/9df78eab33525d08d6e5fb8d27136e95/h/y/hypericum_xi._orange_gem_1000px.jpg",
        imageLink:
          "https://www.classicroses.co.uk/hypericum-x-inodorum-orange-gem-syn-h-xi-magical-beauty.html",
      },
      {
        image:
          "https://www.bootendart.co.uk/wp-content/uploads//2016/09/Hypericum-inodorum-Red-Gem-Toepassing-500x375.png",
        imageLink:
          "https://www.bootendart.co.uk/introducties/shrubs/hypericum-red-gem/",
      },
    ],
  },
  32: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.penlanperennials.co.uk/wp-content/uploads/2015/10/Astrantia-major-Rosensinfonie-e1508593621768.jpg",
        imageLink:
          "https://www.penlanperennials.co.uk/plant/shade-and-woodland-plants/astrantia-major-rosensinfonie/",
      },
      {
        image:
          "https://s3.amazonaws.com/finegardening.s3.tauntoncloud.com/app/uploads/2018/01/23224407/astrantiamajor_dt_2_lg_0-main.jpg",
        imageLink:
          "https://www.finegardening.com/plant/masterwort-astrantia-major",
      },
      {
        image:
          "https://wimastergardener.org/files/2016/06/Astrantia-leaves.jpg",
        imageLink:
          "https://wimastergardener.org/article/astrantia-astrantia-major/",
      },
      {
        image:
          "https://www.gardenia.net/rendition.slider_detail/uploads/plant/1470060796-32ebd6b70bd947d9d/astrantia-roma-soft.jpg",
        imageLink:
          "https://www.gardenia.net/plant/astrantia-major-roma-great-masterwort",
      },
    ],
  },
  33: {
    gardenImages: [],
    googleImages: [
      {
        image: "https://plants.connon.ca/Content/Images/Photos/G074-23.jpg",
        imageLink:
          "https://plants.connon.ca/11100004/Plant/2142/Sprite_Astilbe",
      },
      {
        image: "https://bethchatto.2dimg.com/4/1446039491_3025.jpg",
        imageLink:
          "https://www.bethchatto.co.uk/plants-for-damp-conditions/astilbe-sprite.htm",
      },

      {
        image:
          "https://www.degroot-inc.com/wp-content/uploads/2018/01/Astilbe_Sprite2.jpg",
        imageLink:
          "https://www.degroot-inc.com/product/astilbe-simplicifolia-sprite/",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Astilbe_Sprite_simplicifolia_hybrid_7_1024x1024.JPG?v=1482147371",
        imageLink:
          "https://www.ballyrobertgardens.com/products/astilbe-sprite-simplicifolia-hybrid",
      },
    ],
  },
  34: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/20/00/01/57/pl2000015723.jpg?width=940&height=940",
        imageLink:
          "https://www.crocus.co.uk/plants/_/asarum-europaeum/classid.2000015723/",
      },
      {
        image:
          "https://paramountnursery.ca/wp-content/uploads/2019/04/Asarum-europaeum.jpg",
        imageLink:
          "https://paramountnursery.ca/product/asarum-europaeum-wild-ginger/",
      },
      {
        image:
          "https://www.gardenia.net/rendition.slider_detail/uploads/plant/1470053947-4d31237b379f066c5/asarum-eurpoaeum.jpg",
        imageLink:
          "https://www.gardenia.net/plant/Asarum-Europaeum-European-Wild-Ginger",
      },
      {
        image: "https://s3.eu-west-2.amazonaws.com/jparkers/265/0011299.jpg",
        imageLink:
          "https://www.jparkers.co.uk/asarum-europaeum-wild-ginger-0011299c",
      },
    ],
  },
  35: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.woottensplants.com/wp-content/uploads/2015/02/a1798a.jpg",
        imageLink:
          "https://www.woottensplants.com/product/aconitum-henryi-sparks-variety/",
      },
      {
        image:
          "http://apps.rhs.org.uk/plantselectorimages/detail/WSY0035683_4336.jpg",
        imageLink:
          "https://www.rhs.org.uk/Plants/89282/i-Aconitum-i-Spark-s-Variety/Details",
      },
      {
        image:
          "https://www.shiptonbulbs.co.uk/wp-content/uploads/2018/09/Aconitum-henryi-Sparks-Variety-e1539708328104.jpg",
        imageLink:
          "https://www.shiptonbulbs.co.uk/product/aconitum-henryi-sparks-variety-autumn/",
      },
      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/2/20/Aconitum_henryi_spark%60s_variety_0.2_R.jpg",
        imageLink:
          "https://commons.wikimedia.org/wiki/File:Aconitum_henryi_spark%60s_variety_0.2_R.jpg",
      },
    ],
  },
  36: {
    gardenImages: [
      {
        image: "/IMG_1546.jpg",
      },
    ],
    googleImages: [
      {
        image:
          "https://elainezengplants.files.wordpress.com/2014/07/rodgersia-pinnata.jpg",
        imageLink:
          "https://elainezengplants.wordpress.com/2014/07/15/rodgersia-pinnata/",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Rodgersia_pinnata_Superba_1_1024x1024.jpg?v=1456394157",
        imageLink:
          "https://www.ballyrobertgardens.com/products/rodgersia-pinnata-superba",
      },

      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/5/58/Rodgersia_pinnata_var._%27Superba%27.jpg",
        imageLink: "https://en.wikipedia.org/wiki/Rodgersia_pinnata",
      },

      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Rodgersia_pinnata_Superba_1_1024x1024.jpg?v=1456394157",
        imageLink:
          "https://www.ballyrobertgardens.com/products/rodgersia-pinnata-superba",
      },
    ],
  },
  37: {
    gardenImages: [
      {
        image: "/IMG_1389.jpg",
      },
    ],
    googleImages: [
      {
        image: "https://pfaf.org/Admin/PlantImages/PeriplocaGraeca2.jpg",
        imageLink:
          "https://pfaf.org/user/Plant.aspx?LatinName=Periploca+graeca",
      },
      {
        image:
          "https://i.pinimg.com/originals/6f/a9/94/6fa99403fb8f1747745857772156a4b4.jpg",
        imageLink: "https://www.pinterest.com/pin/300193131396110648/",
      },
      {
        image:
          "https://i.pinimg.com/originals/ba/a1/d7/baa1d7bc49ac3af093d3b5c35ba8854c.jpg",
        imageLink: "https://www.pinterest.com/pin/122934264804871034/",
      },
      {
        image:
          "http://www.freenatureimages.eu/Plants/Flora%20O-R/Periploca%20graeca/Periploca%20graeca%202%2C%20Saxifraga-Jasenka%20Topic.jPg",
        imageLink:
          "http://www.freenatureimages.eu/Plants/Flora%20O-R/Periploca%20graeca/index.html",
      },
    ],
  },
  38: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Campanula_garganica_Mrs_Resholt_1_1024x1024.jpg?v=1452855696",
        imageLink:
          "https://www.ballyrobertgardens.com/products/campanula-garganica-mrs-resholt",
      },
      {
        image:
          "https://cdn.webvanta.com/000000/51/74/sm/uploads/plant/1509383972-c77219ad5e8aa747d/PL151186%20Optimized.jpg",
        imageLink:
          "https://www.gardenia.net/plant/Campanula-garganica-Dickson-Gold-Adriatic-Bellflower",
      },
      {
        image:
          "https://apps.rhs.org.uk/plantselectorimages/detail/WSY0050626_5454.jpg",
        imageLink:
          "https://www.rhs.org.uk/Plants/93725/i-Campanula-garganica-i-W-h-Paine/Details",
      },
      {
        image:
          "http://www.perennials.com/watermark.php?path=perennials/1-110-260.jpg&watermark=images/watermark_heritage.png&xpos=.88&ypos=.95",
        imageLink:
          "http://www.perennials.com/plants/campanula-garganica-dicksons-gold.html",
      },
    ],
  },
  39: {
    gardenImages: [],
    googleImages: [
      {
        image: "https://www.bluebellnursery.com/catalogue/images/8734167_2.jpg",
        imageLink:
          "https://www.bluebellnursery.com/catalogue/climbers/Parthenocissus/P/8734167",
      },
      {
        image:
          "https://www.bambooplants.ca/wp-content/uploads/2018/05/Parthenocissus-quinquefolia-Engelmannii-wall-vine.jpg",
        imageLink:
          "https://www.bambooplants.ca/product/engelmanns-ivy-parthenocissus-canada/",
      },
      {
        image:
          "https://kurowski.pl//images/katalog/1100_900/Parthenocissus_q_Engelmanii_big.jpg",
        imageLink:
          "https://kurowski.pl/en/catalogue-plants/1/6/plant/134,parthenocissus-quinquefolia-var-engelmannii",
      },

      {
        image:
          "https://paramountnursery.ca/wp-content/uploads/2016/04/PARTHENOCISSUS-quinquefolia-Engelmannii.jpg",
        imageLink:
          "https://paramountnursery.ca/product/parthenocissus-quinquefolia-engelmannii-engelman-ivy/5145482154/",
      },
    ],
  },
  40: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Epimedium_x_youngianum_Roseum_2_nbrcg_2x3_1024x1024.jpg?v=1463650566",
        imageLink:
          "https://www.ballyrobertgardens.com/products/epimedium-x-youngianum-roseum",
      },
      {
        image:
          "https://dorsetperennials.co.uk/wp-content/uploads/2014/06/Epimedium-youngianum-Roseum-2-400x400.jpg",
        imageLink:
          "https://dorsetperennials.co.uk/product/epimedium-x-youngianum-roseum/",
      },

      {
        image:
          "http://apps.rhs.org.uk/plantselectorimages/detail/WSYD0005422_5481.jpg",
        imageLink:
          "https://www.rhs.org.uk/Plants/94565/Epimedium-x-youngianum-Roseum/Details",
      },
      {
        image:
          "https://www.joycreek.com/images/epimedium-youngianum-roseum-322-007-2.jpg",
        imageLink:
          "https://www.joycreek.com/Epimedium-youngianum-Roseum-322-007.htm",
      },
    ],
  },
  41: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://cdn.nexternal.com/romence/images/WG-Brunnera_JackFrost-main3.jpg",
        imageLink:
          "https://shop.romencegardens.com/brunnera-macrophylla-jack-frost-p1272.aspx",
      },
      {
        image:
          "https://www.gardenia.net/rendition.slider_detail/uploads/plant_family/1501261312-985d40f20d6fa9ef4/54578096_m.jpg",
        imageLink:
          "https://www.gardenia.net/plant-variety/brunnera-macrophylla-siberian-bugloss",
      },
      {
        image:
          "https://cdn.nexternal.com/romence/images/GW-Brunnera-m-Sea-Heart.jpg",
        imageLink:
          "https://shop.romencegardens.com/brunnera-macrophylla-sea-heart-p1273.aspx",
      },
      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/4/45/Brunnera_macrophylla_01.JPG",
        imageLink:
          "https://commons.wikimedia.org/wiki/File:Brunnera_macrophylla_01.JPG",
      },
    ],
  },
  42: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://s3.amazonaws.com/finegardening.s3.tauntoncloud.com/app/uploads/2018/01/23223855/kirengeshoma_palmata_lg_0-main.jpg",
        imageLink:
          "https://www.finegardening.com/plant/yellow-wax-bells-kirengeshoma-palmata",
      },
      {
        image:
          "http://apps.rhs.org.uk/plantselectorimages/detail/WSY0035690_5250.jpg",
        imageLink:
          "https://www.rhs.org.uk/Plants/9729/Kirengeshoma-palmata/Details",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Kirengeshoma_palmata_Koreana_Group_1_nbrcg_1024x1024.jpg?v=1455726643",
        imageLink:
          "https://www.ballyrobertgardens.com/products/kirengeshoma-palmata-koreana-group",
      },
      {
        image:
          "https://wimastergardener.org/files/2015/12/Kirengeshoma-foliage.jpg",
        imageLink:
          "https://wimastergardener.org/article/yellow-wax-bells-kirengeshoma-palmata/",
      },
    ],
  },
  43: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "http://www.vanberkumnursery.com/wp-content/uploads/2016/01/astilboides-tabularia.jpg",
        imageLink:
          "http://www.vanberkumnursery.com/plant/astilboides-tabularis/",
      },
      {
        image:
          "https://i2.wp.com/awaytogarden.com/wp-content/uploads/2009/02/astilboides-tabularis.jpg?resize=640%2C419&ssl=1",
        imageLink:
          "https://awaytogarden.com/a-plant-id-order-astilboides-tabularis/",
      },

      {
        image:
          "https://www.perennials.com/watermark.php?path=perennials/1-088-010.jpg&watermark=images/watermark_heritage.png&xpos=.88&ypos=.95",
        imageLink:
          "https://www.perennials.com/plants/astilboides-tabularis.html",
      },
      {
        image:
          "https://media-cdn.tripadvisor.com/media/photo-s/08/65/db/74/tartu-university-botanical.jpg",
        imageLink:
          "https://www.tripadvisor.com/LocationPhotoDirectLink-g274959-d2665505-i140893044-Tartu_University_Botanical_Garden-Tartu_Tartu_County.html",
      },
    ],
  },
  44: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.whiteflowerfarm.com/mas_assets/cache/image/4/1/b/f/16831.Jpg",
        imageLink:
          "https://www.whiteflowerfarm.com/eupatorium-maculatum-snowball",
      },
      {
        image:
          "https://staging-claire-austin-hardy-plants.s3.amazonaws.com/products/4299/product/eupatorium-maculatum-Reisenchium18.jpg?1504101545",
        imageLink:
          "https://www.claireaustin-hardyplants.co.uk/products/eupatorium-maculatum-riesenschirm",
      },
      {
        image:
          "https://staging-claire-austin-hardy-plants.s3.amazonaws.com/products/2606/product/eupatorium-maculatum-atropurpureum_.jpg?1424630470",
        imageLink:
          "https://www.claireaustin-hardyplants.co.uk/products/eupatorium-maculatum-atropurpureum",
      },
      {
        image: "https://pfaf.org/Admin/PlantImages/EupatoriumChinense.gif",
        imageLink:
          "https://pfaf.org/USER/Plant.aspx?LatinName=Eupatorium%20chinense",
      },
    ],
  },
  45: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.letsgoplanting.co.uk/wp-content/uploads/ViburnumBodDawn561-1.jpg",
        imageLink:
          "https://www.letsgoplanting.co.uk/product/viburnum-bodnantense-dawn/",
      },
      {
        image:
          "https://greenleafnurseries.co.nz/wp-content/uploads/2018/05/viburnum-bod.-dawn-500.jpg",
        imageLink:
          "https://greenleafnurseries.co.nz/product/viburnum-bodnantense-dawn-2ltr-30-35/",
      },
      {
        image:
          "https://www.thompson-morgan.com/product_images/100/optimised/VIBU-T10951-A.jpg",
        imageLink:
          "https://www.thompson-morgan.com/p/viburnum-x-bodnantense-dawn/t10951TM",
      },
      {
        image: "https://images.esellerpro.com/3048/I/149/42/9CM_VIBBDA_WEB.jpg",
        imageLink:
          "https://www.ebay.ie/itm/1-X-VIBURNUM-BODNANTENSE-DAWN-DECIDUOUS-SHRUB-HARDY-GARDEN-PLANT-IN-POT-/263797258973",
      },
    ],
  },
  47: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://secure.i.telegraph.co.uk/multimedia/archive/03330/Choisya_3330939b.jpg",
        imageLink:
          "https://www.telegraph.co.uk/gardening/gardeningadvice/11653862/How-to-prune-choisya-and-hydrangea.html",
      },
      {
        image:
          "https://farm6.staticflickr.com/5710/22851818352_ede356373a_b.jpg",
        imageLink:
          "https://picssr.com/photos/137292046@N03/interesting/page30?nsid=137292046@N03",
      },
      {
        image:
          "https://secure.i.telegraph.co.uk/multimedia/archive/03330/Helebores_3330979c.jpg",
        imageLink:
          "https://www.telegraph.co.uk/gardening/gardeningadvice/11653862/How-to-prune-choisya-and-hydrangea.html",
      },
      {
        image:
          "https://farm2.staticflickr.com/1492/25897028680_160db79f9e_b.jpg",
        imageLink:
          "https://picssr.com/photos/137292046@N03/interesting/page30?nsid=137292046@N03",
      },
    ],
  },
  48: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/00/00/00/29/pl0000002907.jpg?width=940&height=940",
        imageLink:
          "https://www.crocus.co.uk/plants/_/helleborus-argutifolius/classid.2907/",
      },
      {
        image:
          "https://www.willowslivinggifts.com/wp-content/uploads/2017/11/helleborus-argutifolius.jpg",
        imageLink:
          "https://www.willowslivinggifts.com/shop/flower-shop/birthday-plants/helleborus-argutifolius/",
      },
      {
        image: "https://emeraldplants.co.uk/media/HELLEBOREARGUTIFOLIUS2.jpg",
        imageLink:
          "https://emeraldplants.co.uk/product/helleborus-argutifolius/",
      },
      {
        image:
          "https://www.letsgoplanting.co.uk/wp-content/uploads/HELLEBORUSARGUTIFOLIUS.jpg",
        imageLink:
          "https://www.letsgoplanting.co.uk/product/helleborus-argutifolius/",
      },
    ],
  },
  49: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Campanula_poscharskyana_Stella_5_1024x1024.jpg?v=1478512456",
        imageLink:
          "https://www.ballyrobertgardens.com/products/campanula-poscharskyana-stella",
      },
      {
        image:
          "https://cdn.webvanta.com/000000/51/74/sm/uploads/plant/1508937641-276813c9cbe5e989c/PM121414%20Optimized.jpg",
        imageLink:
          "https://www.gardenia.net/plant/Campanula-poscharskyana-Serbian-Bellflower",
      },
      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/d/d1/Purple_Campanula_poscharskyana.jpg",
        imageLink:
          "https://commons.wikimedia.org/wiki/File:Purple_Campanula_poscharskyana.jpg",
      },
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/81QaYv98qlL._SX425_.jpg",
        imageLink:
          "https://www.amazon.com/Serbian-Bellflower-Blue-Waterfall-seeds/dp/B07CYYP799",
      },
    ],
  },
  50: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.johnnyseeds.com/dw/image/v2/BBBW_PRD/on/demandware.static/-/Sites-jss-master/default/dw5b59a1b9/images/products/flowers/00842_01_purple.jpg?sw=387&cx=302&cy=0&cw=1196&ch=1196",
        imageLink:
          "https://www.johnnyseeds.com/herbs/echinacea-coneflower/echinacea-purpurea-echinacea-seed-842.html",
      },
      {
        image:
          "https://www.gardenia.net/rendition.slider_detail/uploads/plant/1493119603-c9eb60317a071e351/19455.jpg",
        imageLink:
          "https://www.gardenia.net/plant/echinacea-purpurea-magnus-coneflower",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/2194/9573/products/ADP170815_3983_2048x.jpg?v=1511136552",
        imageLink:
          "https://fosterfarmbotanicals.com/products/echinacea-herb-echinacea-purpurea",
      },
      {
        image:
          "https://media2.florihana.com/us/2308-large_default/echinacea-purpurea-flowering-top-organic.jpg",
        imageLink:
          "https://www.florihana.com/us/mother-tinctures/1214-echinacea-purpurea-flowering-top-organic.html",
      },
    ],
  },
  51: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "http://www.brentandbeckysbulbs.com/scale/360/data/Compositae-Eupatorium-rugosum_Chocolate-Joe-Pie_Weed.jpg",
        imageLink:
          "http://www.brentandbeckysbulbs.com/Eupatorium/rugosum-Chocolate/Joe-Pie-Weed",
      },
      {
        image:
          "https://stonehousenursery.com/wp-content/uploads/2018/08/Eupatorium_Chocolate_EUPCHO_SUM_1_A.jpg",
        imageLink:
          "https://stonehousenursery.com/plant/eupatorium-rugosum-chocolate/",
      },
      {
        image:
          "https://www.connonnurseries.com/_ccLib/image/plants/DETA-369.jpg",
        imageLink:
          "https://www.connonnurseries.com/plant/Eupatorium-rugosum-Chocolate",
      },
      {
        image:
          "https://d6p0gevo8s9lm.cloudfront.net/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/e/u/eupatorium-rugosum-chocolate.jpg",
        imageLink:
          "https://www.gardeningexpress.co.uk/p15059-eupatorium-rugosum-chocolate-white-snakeroot",
      },
    ],
  },
  52: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://apps.rhs.org.uk/plantselectorimages/detail/WSY0034447_4595.jpg",
        imageLink:
          "https://www.rhs.org.uk/plants/90145/Berberis-thunbergii-f-atropurpurea-Atropurpurea-Nana/Details",
      },
      {
        image:
          "https://florex.ua/content/images/17/berberis-thunbergii-barbaris-atropurpurea-nana-61832139481017_small11.jpg",
        imageLink:
          "https://florex.ua/en/berberis-thunbergii-barbaris-atropurpurea-nana/",
      },
      {
        image:
          "https://kurowski.pl/images/katalog/1100_900/berberis-thunbergii-atropurpurea-nana2_big.jpg",
        imageLink:
          "https://kurowski.pl/de/pflanzenkatalog/1/1/9,die-deckpflanzen/17,berberis-thunbergii-atropurpurea-nana",
      },
      {
        image:
          "http://countrysidelandscape.net/files/2018/05/Berberis-thunbergii-Atropurpurea-Nana-004.jpg",
        imageLink:
          "http://countrysidelandscape.net/2018/05/01/may-2018-newsletter/berberis-thunbergii-atropurpurea-nana-004/",
      },
    ],
  },
  53: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.andre-briant.fr/media/photinia_fraseri_little_red_robin_1__060148500_1233_07012018.jpg",
        imageLink:
          "https://www.andre-briant.fr/en/variety-range/access-to-varieties/evergreen-shrubs/3552-photinia-fraseri-little-red-robin-.html",
      },
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/20/00/01/17/pl2000011729.jpg?width=940&height=940",
        imageLink:
          "https://www.rhsplants.co.uk/plants/_/shrubs/photinia--fraseri-little-red-robin/itemno.RH30000556/",
      },
      {
        image:
          "https://www.hedgesdirect.co.uk/acatalog/Photinia-x-Fraseri-Little-Red-Robin-At-Nursery.jpg",
        imageLink:
          "https://www.hedgesdirect.co.uk/acatalog/Photinia-x-fraseri-Little-Red-Robin.html",
      },
    ],
  },
  54: {
    gardenImages: [],
    googleImages: [],
  },
  55: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.growjoy.com/store/pc/catalog/agastache_black_adder_plant_1859_detail.jpg",
        imageLink:
          "https://www.growjoy.com/store/pc/Black-Adder-Agastache-Plant-Hummingbird-Mint-p3187.htm",
      },
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/20/00/01/27/pl2000012736.jpg?width=940&height=940",
        imageLink:
          "https://www.crocus.co.uk/plants/_/agastache-blackadder/classid.2000012736/",
      },
    ],
  },
  56: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "http://www.gardenscene.je/wp-content/uploads/2017/05/sedum-spectabile-stardust-2.jpg",
        imageLink:
          "http://www.gardenscene.je/product/sedum-spectabile-stardust/",
      },
      {
        image:
          "https://dorsetperennials.co.uk/wp-content/uploads/2017/02/Sedum-spectabile-Stardust-2-400x400.jpg",
        imageLink:
          "https://dorsetperennials.co.uk/product/sedum-spectabile-stardust/",
      },
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/00/00/00/35/pl0000003594.jpg?width=940&height=940",
        imageLink:
          "https://www.crocus.co.uk/plants/_/hylotelephium-spectabile-stardust/classid.3594/",
      },
      {
        image:
          "https://www.coblands.co.uk/userfiles/product_image/.main/ecomproducts-image-392.jpg",
        imageLink:
          "https://www.coblands.co.uk/products/288-sedum-spectabile-stardust-2l",
      },
    ],
  },
  57: {
    gardenImages: [],
    googleImages: [
      {
        image: "https://emeraldplants.co.uk/media/MoliniaVariegata.jpg",
        imageLink:
          "https://emeraldplants.co.uk/product/molinia-caerulea-subsp-caerulea-variegata/",
      },
      {
        image:
          "https://www.joycreek.com/images/molinia-caerulea-variegata-300-002.jpg",
        imageLink:
          "https://www.joycreek.com/Molinia-caerulea-Variegata-300-002.htm",
      },
      {
        image:
          "https://d6p0gevo8s9lm.cloudfront.net/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/C/9/C91998A6913A680917925DDAF44FBDDC.jpg",
        imageLink:
          "https://www.gardeningexpress.co.uk/g10597-molinia-caerulea-variegata",
      },
      {
        image:
          "https://www.bambooplants.ca/wp-content/uploads/2016/06/Molinea_caerulea_Variegata_habit-1.jpg",
        imageLink:
          "https://www.bambooplants.ca/product/molinia-caerulea-variegata-moor-grass/",
      },
    ],
  },
  58: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.facet.org.uk/images/product_images/5c122ee2ac996.jpg",
        imageLink:
          "https://www.facet.org.uk/product/lavendula-angustifolia-edelweiss",
      },
      {
        image:
          "https://www.brittanyperennials.uk/8231-thickbox_default/lavandula-angustifolia-edelweiss-.jpg",
        imageLink:
          "https://www.brittanyperennials.uk/perennials-for-full-sun-and-ordinary-soil/298-lavandula-angustifolia-edelweiss-.html",
      },
      {
        image:
          "https://www.plantenweelde.nl/wp-content/uploads/2015/11/Lavandula-angustifolia-Edelweiss.jpg",
        imageLink:
          "https://www.plantenweelde.nl/product/lavandula-angustifolia-edelweiss-2/",
      },
    ],
  },
  59: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/3/31/Chocolate_Vine%2C_Akebia_quinata_fruit_%2836368946404%29.jpg",
        imageLink:
          "https://commons.wikimedia.org/wiki/File:Chocolate_Vine,_Akebia_quinata_fruit_(36368946404).jpg",
      },
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/00/00/00/02/pl0000000225.jpg?width=940&height=940",
        imageLink:
          "https://www.crocus.co.uk/plants/_/akebia-quinata/classid.225/",
      },
      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/07/Akebia_quinata_and_Phlox_subulata_02.jpg",
        imageLink:
          "https://commons.wikimedia.org/wiki/File:Akebia_quinata_and_Phlox_subulata_02.jpg",
      },
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/81v-rv4b3EL._SL1500_.jpg",
        imageLink:
          "https://www.amazon.com/AKEBIA-QUINATA-Chocolate-Starter-Plant/dp/B07MT9DYTW",
      },
      {
        image:
          "https://landscapeplants.oregonstate.edu/sites/plantid7/files/plantimage/akqu98.jpg",
        imageLink:
          "https://landscapeplants.oregonstate.edu/plants/akebia-quinata",
      },
      {
        image:
          "http://ketenewplymouth.peoplesnetworknz.info/image_files/0000/0011/2138/1-Akebia_quinata.JPG",
        imageLink:
          "http://www.terrain.net.nz/friends-of-te-henui-group/weeds-by-scientific-names/akebia-quinata-five-leaf-akebi.html",
      },
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/71LgTfV-IOL._SX425_.jpg",
        imageLink:
          "https://www.amazon.com/Akebia-Quinata-Seeds-Chocolate-Five-leafed/dp/B00VEL1N6E",
      },
      {
        image:
          "https://www.botanicaplantnursery.co.uk/user/products/large/akebia-quinata-3029-p.jpg",
        imageLink:
          "https://www.botanicaplantnursery.co.uk/akebia-quinata-3029-p.html",
      },
    ],
  },
  60: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.midwestgroundcovers.com/_ccLib/image/plants/DETA-462.jpg",
        imageLink:
          "https://www.midwestgroundcovers.com/plant/Gypsophila-repens-Rosea",
      },
      {
        image:
          "https://farmyardnurseries.co.uk/wp-content/uploads/2017/11/gypsophila-repens-rosea.jpg",
        imageLink:
          "https://farmyardnurseries.co.uk/shop/alpine/gypsophila-repens-rosea/",
      },
      {
        image:
          "http://www.flowermedia.com/static2/preview2/stock-photo-gypsophila-repens-rosea--creeping-gypsophila-110247-19261.jpg",
        imageLink:
          "https://www.flowermedia.com/stock-photo/gypsophila-repens-rosea-creeping-gypsophila-110247-19261.html",
      },
      {
        image:
          "https://www.vanmeuwen.com/product_images/101/optimised/gypsophila-rosea.jpg",
        imageLink:
          "https://www.vanmeuwen.com/p/gypsophila-repens-rosea/61320VM",
      },
      {
        image:
          "https://boundarynursery.co.uk/wp-content/uploads/2013/11/Gypsophila-repens-Rosea.jpg",
        imageLink:
          "https://boundarynursery.co.uk/shop-for-plants/gypsophila-repens-rosea-alpine/",
      },
      {
        image:
          "https://www.midwestgroundcovers.com/_ccLib/image/plants/DETA2-462.jpg",
        imageLink:
          "https://www.midwestgroundcovers.com/plant/Gypsophila-repens-Rosea",
      },
      {
        image:
          "https://www.classicroses.co.uk/media/catalog/product/cache/1/image/443x443/9df78eab33525d08d6e5fb8d27136e95/g/y/gypsophila_repens_rosea_bm_2015_13_1000px.jpg",
        imageLink:
          "https://www.classicroses.co.uk/gypsophila-repens-rosea.html",
      },
      {
        image:
          "http://www.jardinjasmin.com/catalogue/userfiles/productlargeimages/2453.jpg",
        imageLink:
          "http://www.jardinjasmin.com/catalogue/product.php?ProductID=1252&UILanguage=EN",
      },
    ],
  },
  61: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://p7011128.vo.llnwd.net/e1/wp-content/uploads/plants/originals/837.jpg",
        imageLink:
          "https://www.monrovia.com/plant-catalog/plants/907/hummingbird-summersweet/",
      },
      {
        image:
          "https://s3.amazonaws.com/finegardening.s3.tauntoncloud.com/app/uploads/2018/01/23225823/clethra_alnifolia_hummingbird_lg_0-main.jpg",
        imageLink:
          "https://www.finegardening.com/plant/sweet-pepperbush-clethra-alnifolia-hummingbird",
      },
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/81rdzwrYsHL._SX425_.jpg",
        imageLink:
          "https://www.amazon.com/Mini-Garden-CLETHRA-ALNIFOLIA-HUMMINGBIRD/dp/B07F17FLFD",
      },
      {
        image:
          "http://klynnurseries.com/wp-content/uploads/2016/08/Clethra-a.-Humingbird-1.jpg",
        imageLink:
          "http://klynnurseries.com/product/clethra-alnifolia-hummingbird/",
      },
      {
        image:
          "https://plants.westonnurseries.com/Content/Images/Photos/F976-13.jpg",
        imageLink:
          "https://plants.westonnurseries.com/12130019/Plant/701/Hummingbird_Summersweet",
      },
      {
        image:
          "https://www.saundersbrothers.com/_ccLib/image/plants/DETA-743.jpg",
        imageLink:
          "https://www.saundersbrothers.com/plant/Clethra-alnifolia-Hummingbird",
      },
      {
        image:
          "https://springmeadownursery.com/images/made/files/plant_images/Clethra%20Hummingbird%201_1080_1080_60.jpg",
        imageLink:
          "https://springmeadownursery.com/plantfinder/hummingbird-16080",
      },
      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/b/bf/Clethra_alnifolia_Hummingbird_kz2.jpg",
        imageLink:
          "https://commons.wikimedia.org/wiki/File:Clethra_alnifolia_Hummingbird_kz2.jpg",
      },
    ],
  },
  62: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "http://www.perennials.com/watermark.php?path=perennials/1-108-150.jpg&watermark=images/watermark_heritage.png&xpos=.88&ypos=.95",
        imageLink:
          "http://www.perennials.com/plants/calamintha-nepeta-ssp-nepeta.html",
      },
      {
        image:
          "https://staging-claire-austin-hardy-plants.s3.amazonaws.com/products/1056/product/mpp_calamintha-blue-cloud2.jpg?1403040922",
        imageLink:
          "https://www.claireaustin-hardyplants.co.uk/products/calamintha-nepeta-blue-cloud",
      },
      {
        image: "http://www.newmoonnursery.com/_ccLib/image/plants/DETA-594.jpg",
        imageLink:
          "http://www.newmoonnursery.com/plant/Calamintha-nepeta-sp-nepeta",
      },
      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CalaminthaNepetaNepeta.jpg/1200px-CalaminthaNepetaNepeta.jpg",
        imageLink:
          "https://en.wikipedia.org/wiki/Calamintha_nepeta_subsp._nepeta",
      },
      {
        image:
          "https://staging-claire-austin-hardy-plants.s3.amazonaws.com/products/1055/product/mpp_calamintha-nepeta4.jpg?1403040919",
        imageLink:
          "https://www.claireaustin-hardyplants.co.uk/products/calamintha-nepeta",
      },
      {
        image:
          "http://plants.oaklandnursery.com/Content/Images/Photos/J343-16.jpg",
        imageLink:
          "http://plants.oaklandnursery.com/12130001/Plant/2171/Dwarf_Calamint",
      },
      {
        image:
          "https://www.midwestgroundcovers.com/_ccLib/image/plants/DETA-1198.jpg",
        imageLink:
          "https://www.midwestgroundcovers.com/plant/Calamintha-nepeta-ssp-nepeta",
      },
    ],
  },
  63: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/b/b6/Helleborus_orientalis._Lenteroos_04.JPG",
        imageLink:
          "https://en.wikipedia.org/wiki/File:Helleborus_orientalis._Lenteroos_04.JPG",
      },
      {
        image:
          "https://s3.amazonaws.com/cdn0.dutchbulbs.com/images/500/89472.jpg",
        imageLink:
          "https://www.dutchbulbs.com/product/helleborus-orientalis-mix",
      },
      {
        image:
          "https://worldoffloweringplants.com/wp-content/uploads/2017/12/Helleborus-orientalis-Lenten-Rose4.jpg",
        imageLink:
          "https://worldoffloweringplants.com/helleborus-orientalis-lenten-rose/",
      },
      {
        image:
          "https://img.sunset02.com/sites/default/files/styles/4_3_horizontal_inbody_900x506/public/image/2016/10/main/perennial-helleborus.jpg",
        imageLink:
          "https://www.sunset.com/garden/flowers-plants/lenten-rose-helleborus-orientalis",
      },
      {
        image:
          "https://www.florablom.com/media/catalog/product/cache/4/image/9df78eab33525d08d6e5fb8d27136e95/1/5/1551346814helleborus__4____agp/helleborus-orientalis-%E2%80%98pretty-ellen-pink%E2%80%99.jpg",
        imageLink:
          "https://www.florablom.com/en/helleborus-orientalis-pretty-ellen-pink/",
      },
      {
        image:
          "http://www.freenatureimages.eu/Plants/Flora%20D-I/Helleborus%20orientalis/Helleborus%20orientalis%201%2C%20Saxifraga-Jeroen%20Willemsen.jpg",
        imageLink:
          "http://www.freenatureimages.eu/Plants/Flora%20D-I/Helleborus%20orientalis/index.html",
      },
      {
        image:
          "https://previews.123rf.com/images/spring75/spring751803/spring75180300114/96733450-helleborus-orientalis-inflorescence.jpg",
        imageLink:
          "https://www.123rf.com/photo_96733450_helleborus-orientalis-inflorescence.html",
      },
      {
        image: "http://ucanr.edu/blogs/byg/blogfiles/32567_original.jpg",
        imageLink:
          "https://ucanr.edu/blogs/blogcore/postdetail.cfm?postnum=19201",
      },
      {
        image:
          "https://www.letsgoplanting.co.uk/wp-content/uploads/HELLEBORUSORIENTALIS1-1.jpg",
        imageLink:
          "https://www.letsgoplanting.co.uk/product/helleborus-orientalis/",
      },
    ],
  },
  64: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.botanicaplantnursery.co.uk/user/products/large/Cercidiphyllum%20japonicum.JPG",
        imageLink:
          "https://www.botanicaplantnursery.co.uk/cercidiphyllum-japonicum-3939-p.html",
      },
      {
        image:
          "https://www.ornamental-trees.co.uk/images/cercidiphyllum-japonicum-tree-p287-729_medium.jpg",
        imageLink:
          "https://www.ornamental-trees.co.uk/cercidiphyllum-japonicum-tree-p287",
      },
      {
        image:
          "https://www.plantstoplant.com/Files/71136/Img/15/Cercidiphyllum-japonicum-002-zoom.jpg",
        imageLink:
          "https://www.plantstoplant.com/cercidiphyllum-japonicum-c2x21771005",
      },
      {
        image:
          "https://www.marshalls-seeds.co.uk/images/products/product_11810.jpg",
        imageLink:
          "https://www.marshalls-seeds.co.uk/cercidiphyllum-japonicum-katsura-tree-4l-potted-tree-pid11810.html",
      },
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/61f%2BQbvFygL._SX466_.jpg",
        imageLink:
          "https://www.amazon.com/Katsura-Tree-Seeds-Cercidiphyllum-japonicum/dp/B07H86SDRK",
      },
      {
        image:
          "https://pfaf.org/Admin/PlantImages/CercidiphyllumJaponicum2.jpg",
        imageLink:
          "https://pfaf.org/user/Plant.aspx?LatinName=Cercidiphyllum%20japonicum",
      },
      {
        image:
          "https://cdn10.bigcommerce.com/s-z923x0f/products/1145/images/1471/Katsura20Tree20fc20tree1new1__52672.1455550375.800.1280.jpg?c=2",
        imageLink:
          "http://shop.bluerivernursery.com/plants/shade-trees/cercidiphyllum-japonicum/",
      },
      {
        image:
          "http://jardinjasmin.com/catalogue/userfiles/productlargeimages/product_3356.jpg",
        imageLink:
          "http://jardinjasmin.com/catalogue/product.php?ProductID=17&UILanguage=EN",
      },
    ],
  },
  65: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.gardenia.net/rendition.slider_detail/uploads/plant/1501698640-76bcf72b504217db2/Pervoskia%20atriplicifolia%20Blue%20Spire.jpg",
        imageLink:
          "https://www.gardenia.net/plant/perovskia-Blue-Spire-russian-sage",
      },
      {
        image:
          "https://www.jparkers.co.uk/news/wp-content/uploads/2017/11/perovskia-atriplicifolia-Blue-Spire-in-garden.jpg",
        imageLink:
          "https://www.jparkers.co.uk/news/august-plant-of-the-month-perovskia-atriplicifolia-blue-spire/",
      },
      {
        image: "https://s3.eu-west-2.amazonaws.com/jparkers/265/0004109.jpg",
        imageLink:
          "https://www.jparkers.co.uk/3-perovskia-atrip-blue-spire-0004109c",
      },
      {
        image:
          "https://www.andre-briant.fr/media/perovskia_atriplicifolia_blue_spire__045272100_1711_01012018.jpg",
        imageLink:
          "https://www.andre-briant.fr/en/variety-range/access-to-varieties/deciduous-shrubs/4462-perovskia-atriplicifolia-blue-spire-.html",
      },
      {
        image: "https://s3.eu-west-2.amazonaws.com/jparkers/1000/0004109.jpg",
        imageLink:
          "https://www.jparkers.co.uk/3-perovskia-atrip-blue-spire-0004109c",
      },
      {
        image:
          "https://static.99roots.com/uploads/images/Perovskia-atriplicifolia-Blue-Spire_6130_1280_1280.jpg",
        imageLink:
          "https://www.99roots.com/en/plants/russian-sage-blue-spire-p40740",
      },
      {
        image:
          "https://e54055a024bc6fb58d47-f7df714a3b816a175961a96ef2278d84.ssl.cf2.rackcdn.com/4180-Blue-Spire-Russian-Sage.jpg",
        imageLink:
          "https://www.togogarden.com/buy-plants/perennial-plants/perovskia-russian-sage-for-sale/blue-spire-russian-sage-lamiaceae-perovskia-atriplicifolia-blue-spire-1-gallon/698",
      },
    ],
  },
  66: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Filipendula_purpurea_Elegans_1_1024x1024.jpg?v=1454405531",
        imageLink:
          "https://www.ballyrobertgardens.com/products/filipendula-purpurea-elegans",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Filipendula_purpurea_1_1024x1024.jpg?v=1551184418",
        imageLink:
          "https://www.ballyrobertgardens.com/products/filipendula-purpurea",
      },
      {
        image:
          "https://mountvenusnursery.com/wp-content/uploads/2018/03/Filipendula-purpurea-Elegans-396-71b5c629-640x512.jpg",
        imageLink:
          "https://mountvenusnursery.com/catalogue/product/filipendula-purpurea-elegans/",
      },
      {
        image:
          "http://cdn.shopify.com/s/files/1/1527/8799/products/Filipendula-purpurea.i-9241.s-62411.r-1_3ce38a0e-9363-4f70-b239-8d0d3e92d825_grande.jpg?v=1476652768",
        imageLink:
          "https://www.plantdelights.com/products/filipendula-purpurea",
      },
      {
        image:
          "https://apps.rhs.org.uk/plantselectorimages/detail/HYD0000674_2941.jpg",
        imageLink:
          "https://www.rhs.org.uk/plants/7218/Filipendula-purpurea/Details",
      },
      {
        image:
          "https://www.gardensonline.com.au/Uploads/Plant/995/filipendula-purpurea-flowerMain.jpg",
        imageLink:
          "https://www.gardensonline.com.au/gardenshed/plantfinder/show_995.aspx",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/0085/4882/products/Filipendula_purpurea_1506_1024x1024.jpg?v=1515967134",
        imageLink:
          "https://www.keepingitgreennursery.com/products/filipendula-purpurea-japanese-purple-meadowsweet",
      },
      {
        image:
          "https://296934.smushcdn.com/447580/wp-content/uploads/2015/02/filipendula_purpurea_elegans.jpeg?size=640x480&lossy=1&strip=1&webp=1",
        imageLink:
          "https://www.penlanperennials.co.uk/plant/pond-and-bog-plants/filipendula-purpurea-elegans/",
      },
      {
        image:
          "http://cdn.shopify.com/s/files/1/1069/2032/products/Filipendula_purpurea_Elegans_1_grande.jpg?v=1454405531",
        imageLink:
          "https://www.ballyrobertgardens.com/products/filipendula-purpurea-elegans",
      },
    ],
  },
  67: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "http://www.perennials.com/watermark.php?path=perennials/1-278-650.jpg&watermark=images/watermark_heritage.png&xpos=.88&ypos=.95",
        imageLink:
          "http://www.perennials.com/plants/hosta-sieboldiana-elegans.html",
      },
      {
        image:
          "https://cdn11.bigcommerce.com/s-d9kuzm38/images/stencil/1280x1280/products/621/3284/Elegans_Hosta_2__52104.1447863286.jpg?c=2&imbypass=on",
        imageLink:
          "https://www.nhhostas.com/sieboldiana-elegans-hosta-two-gallon/",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1537/5553/products/53714_1024x1024.jpg?v=1518033093",
        imageLink:
          "https://www.harrisseeds.com/products/53714-hosta-sieboldiana-elegans",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Hosta_sieboldiana_var._elegans_1_nbrcg_wi_1024x1024.jpg?v=1455102478",
        imageLink:
          "https://www.ballyrobertgardens.com/products/hosta-sieboldiana-var-elegans",
      },
    ],
  },
  68: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/20/00/01/44/pl2000014460.jpg?width=940&height=940",
        imageLink:
          "https://www.rhsplants.co.uk/plants/_/hydrangea-arborescens-incrediball-abetwo-pbr/classid.2000014460/",
      },
      {
        image:
          "http://www.perfectplantdeal.nl/images/tuinplanten/Hydrangea%20arb%20Strong%20Annabelle.jpg",
        imageLink:
          "http://www.perfectplantdeal.nl/garden-plants-hydrangea-strong-annabelle-p-896.html?language=en",
      },
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/20/00/01/29/pl2000012942_card2_lg.jpg",
        imageLink:
          "https://www.waitrosegarden.com/plants/_/hydrangea-arborescens-incrediball-abetwo-pbr/classid.2000012942/",
      },
      {
        image: "https://suttons.s3.amazonaws.com/p/FLSHYD33667_3.jpg",
        imageLink:
          "https://www.suttons.co.uk/Gardening/Trees-and-Shrubs/All-Trees-and-Shrubs/Hydrangea-arborescens-Plant---Strong-Annabelle_297361.htm",
      },
      {
        image:
          "https://assets.bakker.com/ProductPics/810x978/90550-05-BAKI_20140409124436.jpg",
        imageLink:
          "https://www.bakker.com/en-gb/p/hydrangea-strong-annabelle-M50692",
      },
      {
        image:
          "https://www.thompson-morgan.com/product_images/100/optimised/HYDR-T62048-A_h.jpg",
        imageLink:
          "https://www.thompson-morgan.com/p/hydrangea-arborescens-strong-annabelle/t62048TM",
      },
      {
        image:
          "https://assets.bakker.com/ProductPics/810x978/90550-04-BAKIE_20120504200500.jpg",
        imageLink:
          "https://www.bakker.com/en-gb/p/hydrangea-strong-annabelle-M50692",
      },
    ],
  },
  69: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.gardenia.net/rendition.slider_detail/uploads/plant/1547561470-db4d1b6e13480758e/shutterstock_639170440Optimized.jpg",
        imageLink:
          "https://www.gardenia.net/plant/Acer-palmatum-Garnet-Japanese-Maple",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1990/4497/products/image_1024x1024.jpg?v=1531125080",
        imageLink:
          "https://treesnturf.com/products/acer-palmatum-japanese-maple",
      },
      {
        image:
          "https://www.ornamental-trees.co.uk/images/acer-palmatum-osakazuki-tree-p265-6606_image.jpg",
        imageLink:
          "https://www.ornamental-trees.co.uk/acer-palmatum-osakazuki-tree-p265",
      },
      {
        image:
          "https://www.mendocinomaples.com/new_images/products/Apalm-sca1-1000.jpg",
        imageLink:
          "https://www.mendocinomaples.com/acer-palmatum/acer-palmatum",
      },
      {
        image:
          "https://clarenbridgegardencentre.ie/wp-content/uploads/2015/05/acer-palmatum-bloodgood.jpg",
        imageLink:
          "https://clarenbridgegardencentre.ie/online-garden-shop/trees/acer-palmatum-bloodgood/",
      },
      {
        image:
          "https://www.gardenia.net/rendition.slider_detail/uploads/plant_family/1546451500-7f00caf4999625999/62538341_mOptimized.jpg",
        imageLink:
          "https://www.gardenia.net/plant-variety/acer-palmatum-japanese-maple",
      },
    ],
  },
  70: {
    gardenImages: [],
    googleImages: [
      {
        image: "https://pfaf.org/Admin/PlantImages/BergeniaCordifolia2.jpg",
        imageLink:
          "https://pfaf.org/user/Plant.aspx?LatinName=Bergenia%20cordifolia",
      },
      {
        image:
          "https://www.gardenia.net/rendition.slider_detail/uploads/plant/1469457253-6d171119d56881890/28357715_m.jpg",
        imageLink:
          "https://www.gardenia.net/plant/Bergenia-CordifoliaHeartleaf-Bergenia",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1008/4432/products/Heartleaf_Bergenia_2.jpg?v=1543343287",
        imageLink:
          "https://underthesunseeds.com/products/heartleaf-bergenia-flower-seeds-bergenia-cordifolia-15-seeds",
      },
      {
        image:
          "https://cdn3.volusion.com/lhqsg.yeuga/v/vspfiles/photos/BergeniaWinterGlow-2.jpg?1554194711",
        imageLink:
          "https://www.parransgreenhouse.com/bergenia-cordifolia-winter-glow-p/bergeniawinterglow.htm",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/0991/1958/products/4527594099_54103d0935_b_2048x.jpg?v=1458748293",
        imageLink:
          "https://www.secretgardeningclub.co.uk/products/3-x-bergenia-cordifolia-9cm-pot3x",
      },
      {
        image: "https://i.ebayimg.com/images/g/lNkAAOSwoT1a50mE/s-l300.jpg",
        imageLink:
          "https://www.ebay.ie/itm/Bergenia-cordifolia-Elephants-Ears-Plant-in-9cm-Pot-/153003623671",
      },
    ],
  },
  71: {
    gardenImages: [],
    googleImages: [],
  },
  72: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://p7011128.vo.llnwd.net/e1/wp-content/uploads/plants/originals/4107.jpg",
        imageLink:
          "https://www.monrovia.com/plant-catalog/plants/2491/emerald-n-gold-wintercreeper/",
      },
      {
        image:
          "https://mobileimages.lowes.com/product/converted/008776/008776014955.jpg",
        imageLink:
          "https://www.lowes.com/pd/2-Gallon-White-Emerald-N-Gold-Euonymus-Accent-Shrub-in-Pot-L9280/3625062",
      },
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/00/00/00/38/pl0000003818.jpg?width=940&height=940",
        imageLink:
          "https://www.rhsplants.co.uk/plants/_/euonymus-fortunei-emerald-n-gold/classid.3818/",
      },
      {
        image:
          "https://www.gardensoyvey.com/uploads/9/6/0/9/96093654/s922031473971641085_p1337_i1_w960.jpeg",
        imageLink:
          "https://www.gardensoyvey.com/store/p1337/Emerald'n_Gold_Wintercreeper_(Euonymus_fortunei).html",
      },
    ],
  },
  73: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/51UoPaUcWuL.jpg",
        imageLink:
          "https://www.amazon.com/VERONICA-SIGHTSEEING-MIXTURE-Speedwell-Veronica/dp/B004ZA7G44",
      },
      {
        image:
          "http://cdn.shopify.com/s/files/1/1527/8799/products/Veronica-spicata-Glory-PP-18932.i-4359.s-64482.r-1_c37a42bf-3bf8-4d5b-9dd9-4f6d99bdf2b3_grande.jpg?v=1483052479",
        imageLink:
          "https://www.plantdelights.com/products/veronica-spicata-glory-pp-18932",
      },
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/20/00/02/04/pl2000020452.jpg?width=440&height=440",
        imageLink:
          "https://www.crocus.co.uk/plants/_/veronica-spicata-glory-pbr/classid.2000020452/",
      },
      {
        image:
          "https://cdn.nexternal.com/romence/images/WG-Veronica_PinkPotion-main3.jpg",
        imageLink:
          "https://shop.romencegardens.com/veronica-spicata-magic-show--pink-potion-p811.aspx",
      },
    ],
  },
  74: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "http://web03.bruns.de/static/images/info/1200Wx1200H/Philadelphus_Dame_Blanche_2008_4120.jpeg",
        imageLink:
          "http://web03.bruns.de/bruns/en/EUR///PHILADELPHUS-%27Dame-Blanche%27/p/1451",
      },
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/81EY20jOJiL._SY355_.jpg",
        imageLink:
          "https://www.amazon.co.uk/Philadelphus-Dame-Blanche-4-shrubs/dp/B06XGGLSMF",
      },
      {
        image:
          "http://doubledash.co.uk/collection/images/Philadelphus%20Dame%20Blanche.jpg",
        imageLink:
          "http://doubledash.co.uk/collection/pages/Philadelphus%20Dame%20Blanche.htm",
      },
      {
        image:
          "https://shop.lve-baumschule.de/media/image/d5/15/b5/Philadelphus-Dame-Blanche-8983.jpg",
        imageLink:
          "https://shop.lve-baumschule.de/en/deciduous-species/1461/philadelphus-dame-blanche",
      },
    ],
  },
  75: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.baumschule-horstmann.de/bilder/community/popup/bauernhortensie-bouquet-rose-m006402-420086-0.JPG",
        imageLink:
          "https://www.baumschule-horstmann.de/shop/exec/product/1459/6402/Ballhortensie-Bouquet-Rose.html",
      },
      {
        image:
          "https://www.scotplantsdirect.co.uk/image/cache/data/HYDRANGEA/HYDRANGEA%20BOUQUET%20ROSE/HYDRANGEA%20BOUQUET%20ROSE-500x500.jpg",
        imageLink:
          "https://www.scotplantsdirect.co.uk/plants/garden/hydrangea/hydrangea-paniculata-phantom.html",
      },
      {
        image:
          "https://www.baumschule-horstmann.de/bilder/popup/bauernhortensie-bouquet-rose-m006402_h_0.jpg",
        imageLink:
          "https://www.baumschule-horstmann.de/shop/exec/product/1459/6402/Ballhortensie-Bouquet-Rose.html",
      },
      {
        image:
          "https://dkpo4ygqb6rh6.cloudfront.net/APPELTERN_NL/imageresized/50887/866dfabf90a02a7e6b5ac0e28bc858bb/388_517_90_fixedjpg/hydrangea_macrophylla_bouquet_rose_-_tuinhortensia.jpg",
        imageLink:
          "https://appeltern.nl/nl/tuinadvies/plantenencyclopedie/hydrangea_macrophylla_bouquet_rose_-_tuinhortensia",
      },
    ],
  },
  76: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.woottensplants.com/wp-content/uploads/2015/02/v5170a.jpg",
        imageLink:
          "https://www.woottensplants.com/product/veronica-gentianoides-pallida/",
      },
      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/1/16/Veronica_gentianoides_%27Pallida%27_flowers.jpg",
        imageLink:
          "https://commons.wikimedia.org/wiki/File:Veronica_gentianoides_%27Pallida%27_flowers.jpg",
      },
      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/c/c3/Veronica_gentianoides_%27Pallida%27.jpg",
        imageLink:
          "https://commons.wikimedia.org/wiki/File:Veronica_gentianoides_%27Pallida%27.jpg",
      },
      {
        image:
          "https://www.directplant.nl/media/product/322/ereprijs-veronica-gentianoides-pallida-2651-06d.jpg",
        imageLink:
          "https://www.directplant.nl/ereprijs-veronica-gentianoides-pallida.html",
      },
    ],
  },
  77: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://www.ornamental-trees.co.uk/images/products/medium/1414162977-51416600.jpg",
        imageLink:
          "https://www.ornamental-trees.co.uk/cornus-florida-rubra-tree-p920",
      },
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/61qkI4%2BGqGL._SX425_.jpg",
        imageLink:
          "https://www.amazon.com/Cornus-florida-FLOWERING-DOGWOOD-Southern/dp/B06VTZNHT4",
      },
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/61Tlmh3uvrL._SX425_.jpg",
        imageLink:
          "https://www.amazon.com/FLOWERING-DOGWOOD-cornus-florida-rubra/dp/B004HJAW3U",
      },
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/61orzQ27%2BJL.jpg",
        imageLink:
          "https://www.amazon.com/Cornus-florida-Pink-flowering-Dogwood-10_Seeds/dp/B07BQLHCPT",
      },
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/91hoJ2lIxvL._SX425_.jpg",
        imageLink:
          "https://www.amazon.com/Beauty-Flowering-Dogwood-Cornus-Florida/dp/B07M74JWRR",
      },
      {
        image:
          "https://ae01.alicdn.com/kf/HTB1npyTHVXXXXakXVXXq6xXFXXXt/New-Home-Gaeden-Plant-5-Seeds-Red-Flowering-Dogwood-Cornus-florida-rubra-Tree-Seeds-Free-Shipping.jpg_640x640.jpg",
        imageLink:
          "https://www.aliexpress.com/item/New-Home-Gaeden-Plant-30-Seeds-Red-Flowering-Dogwood-Cornus-florida-rubra-Tree-Seeds-Free-Shipping/1938302734.html",
      },
    ],
  },
  78: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "http://www.vanberkumnursery.com/wp-content/uploads/2016/04/Epimedium-youngianum-Niveum.jpg",
        imageLink:
          "http://www.vanberkumnursery.com/plant/epimedium-youngianum-niveum/",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Epimedium_x_youngianum_Niveum_1_1024x1024.jpg?v=1454071773",
        imageLink:
          "https://www.ballyrobertgardens.com/products/epimedium-x-youngianum-niveum",
      },
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/20/00/01/26/pl2000012677_card4_lg.jpg",
        imageLink:
          "https://www.crocus.co.uk/plants/_/epimedium--youngianum-niveum/classid.2000012677/",
      },
      {
        image:
          "https://www.gardens4you.co.uk/media/catalog/product/cache/1/image/500x/9df78eab33525d08d6e5fb8d27136e95/F/D/FD19024WH_3.jpg",
        imageLink:
          "https://www.gardens4you.co.uk/epimedium-youngianum-niveum-gb-en.html",
      },
      {
        image: "https://bethchatto.2dimg.com/4/1450172655_9961.jpg",
        imageLink:
          "https://www.bethchatto.co.uk/plants-for-shade-conditions/epimedium-x-youngianum-niveum.htm",
      },
      {
        image:
          "https://dorsetperennials.co.uk/wp-content/uploads/2014/02/Epimedium-youngianum-Niveum-1.jpg",
        imageLink:
          "https://dorsetperennials.co.uk/product/epimedium-x-youngianum-niveum/",
      },
      {
        image:
          "http://www.brooksidenursery.co.uk/user/products/large/Epimeidum%20Niveum.jpg",
        imageLink:
          "http://www.brooksidenursery.co.uk/epimedium-youngianum-niveum-garden-ready-9cm-pot.html",
      },
      {
        image:
          "https://calphotos.berkeley.edu/imgs/512x768/0000_0000/0304/0584.jpeg",
        imageLink:
          "https://calphotos.berkeley.edu/cgi/img_query?enlarge=0000+0000+0304+0584",
      },
      {
        image:
          "https://cdn11.bigcommerce.com/s-d9kuzm38/products/514/images/1001/Epimedium-youngianum-Niveum-2__47761.1422999365.500.659.jpg?c=2",
        imageLink:
          "https://www.nhhostas.com/epimedium-x-youngianum-niveum-3-inch-container/",
      },
      {
        image:
          "https://www.perennials.com/watermark.php?path=perennials/1-198-700.jpg&watermark=images/watermark_heritage.png&xpos=.88&ypos=.95",
        imageLink:
          "https://www.perennials.com/plants/epimedium-youngianum-niveum.html",
      },
    ],
  },
  79: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Anemone_hupehensis_var._japonica_Splendens_1_nbrcg_wi_1024x1024.jpg?v=1509443778",
        imageLink:
          "https://www.ballyrobertgardens.com/products/anemone-hupehensis-var-japonica-splendens",
      },
      {
        image:
          "https://davisla4.files.wordpress.com/2014/08/anemone-hupehensis-splendens.jpg",
        imageLink:
          "https://davisla.wordpress.com/2014/08/12/anemone-hupehensis-splendens/",
      },
      {
        image:
          "http://apps.rhs.org.uk/plantselectorimages/detail/RHS_WSY0078270_8770.JPG",
        imageLink:
          "https://www.rhs.org.uk/Plants/278114/Anemone-hupehensis-var-japonica-Splendens/Details",
      },
      {
        image:
          "https://www.gardentags.com/profile/justin/images/223879/750/anemone-hupehensis-var-japonica-splendens.jpeg",
        imageLink:
          "https://www.gardentags.com/profile/justin/anemone-hupehensis-var-japonica-splendens/223879",
      },
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/00/00/00/24/pl0000002462.jpg?width=940&height=940",
        imageLink:
          "https://www.crocus.co.uk/plants/_/anemone-hupehensis-var-japonica-splendens/classid.2462/",
      },
      {
        image:
          "https://www.zauberstaude.de/shop_cfg/Zauberstaude/Anemone_japonica_Splendens_1.jpg",
        imageLink:
          "https://www.zauberstaude.de/shop2/index.php?user=Zauberstaude&clang=uk&hkat=10&proid=5984&skat=31",
      },
    ],
  },
  80: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://cdn.webvanta.com/000000/51/74/sm/uploads/plant/1505323773-7d33f8966d8f8f685/Astilbe_chinensis_var_pumila_HF115439.jpg",
        imageLink:
          "https://www.gardenia.net/plant/astilbe-chinensis-var-pumila-dwarf-chinese-astilbe",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1008/4432/products/Astilbe_Pumila_3.jpg?v=1479871269",
        imageLink:
          "https://underthesunseeds.com/products/astilbe-pumila-flower-seeds",
      },
      {
        image:
          "https://www.outsidepride.com/images/products/detail/gardenflower/astilbepumila.jpg",
        imageLink:
          "https://www.outsidepride.com/seed/flower-seed/astilbe/astilbe-chinensis-pumila.html",
      },
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/51amn1tU3yL.jpg",
        imageLink:
          "https://www.amazon.com/Outsidepride-Astilbe-Chinensis-Pumila-Flower/dp/B004HJ4XW6",
      },
      {
        image:
          "https://www.greatgardenplants.com/images/uploads/383_1193_popup.jpg",
        imageLink:
          "https://www.greatgardenplants.com/product/perennials-shade-plants-astilbe-pumila/shade-perennials",
      },
      {
        image:
          "http://www.vanberkumnursery.com/wp-content/uploads/2016/01/Astilbe-chinensis-Pumila.jpg-1024x849.jpg",
        imageLink:
          "http://www.vanberkumnursery.com/plant/astilbe-chinensis-pumila/",
      },
      {
        image:
          "http://www.vanberkumnursery.com/wp-content/uploads/2016/01/Astilbe-chinensis-Pumila.jpg",
        imageLink:
          "http://www.vanberkumnursery.com/plant/astilbe-chinensis-pumila/",
      },
    ],
  },
  81: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Molinia_caerulea_subsp._arundinacea_Karl_Foerster_2_1024x1024.jpg?v=1455879020",
        imageLink:
          "https://www.ballyrobertgardens.com/products/molinia-caerulea-subsp-arundinacea-karl-foerster",
      },
      {
        image:
          "https://dorsetperennials.co.uk/wp-content/uploads/2018/10/Molinia-Transparent-1.jpg",
        imageLink:
          "https://dorsetperennials.co.uk/product/molinia-caerulea-subsp-arundinacea-karl-foerster/",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Molinia_caerulea_subsp._arundinacea_Karl_Foerster_1_1024x1024.jpg?v=1455879006",
        imageLink:
          "https://www.ballyrobertgardens.com/products/molinia-caerulea-subsp-arundinacea-karl-foerster",
      },
      {
        image:
          "http://static1.squarespace.com/static/5a3ba867b7411c4078a824d6/5a6f1790cab3392730223f54/5a705582085229a821d3cb62/1517311363914/889b.jpg",
        imageLink:
          "https://www.binnyplants.com/grasses/molinia-caerulea-subsp-arundinacea-karl-foerster",
      },
      {
        image:
          "https://www.shootgardening.co.uk/uploaded/images/plant_molinia_caerulea_subsp__arundinacea___karl_foerster___1_83.jpg",
        imageLink:
          "https://www.shootgardening.co.uk/plant/molinia-caerulea-subsp-arundinacea-karl-foerster",
      },
      {
        image:
          "https://mountvenusnursery.com/wp-content/uploads/2018/03/Molinia-caerulea-subsp-arundinacea-Karl-Foerster-1160-4e21daa3-640x512.jpg",
        imageLink:
          "https://mountvenusnursery.com/catalogue/product/molinia-caerulea-subsp-arundinacea-karl-foerster/",
      },
    ],
  },
  82: {
    gardenImages: [],
    googleImages: [],
  },
  83: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://cdn.nexternal.com/romence/images/GW-Geranium-c.-Biokovo.jpg",
        imageLink:
          "https://shop.romencegardens.com/geranium-x-cantabrigiense-biokovo-p1426.aspx",
      },
      {
        image:
          "https://www.gardens4you.eu/media/catalog/product/cache/10/image/500x/9df78eab33525d08d6e5fb8d27136e95/F/D/FD17643WH_3.jpg",
        imageLink:
          "https://www.gardens4you.eu/geranium-cantabrigiense-biokovo-eu-en.html",
      },
      {
        image:
          "http://www.greenscapesmadison.com/wp-content/uploads/2015/02/Geranium-cantabrigiense-Biokovo.jpg",
        imageLink:
          "http://www.greenscapesmadison.com/services/landscape-build-design/softscapes/products/geranium-cantabrigiense-biokovo/",
      },
      {
        image: "https://plants.gertens.com/Content/Images/Photos/F189-01.jpg",
        imageLink:
          "https://plants.gertens.com/12070009/Plant/2370/Biokovo_Cranesbill/",
      },
      {
        image:
          "https://www.botanikfoto.com/layout/image-photo-cranesbill-geranium-cantabrigiense-biokovo-575110.jpg",
        imageLink:
          "https://www.botanikfoto.com/en/details/image-photo-cranesbill-geranium-cantabrigiense-biokovo-575110.php",
      },
      {
        image:
          "https://www.smgrowers.com/imagedb/Geranium_cantabrigiense_Biokovo.JPG",
        imageLink:
          "https://www.smgrowers.com/products/plants/plantdisplay.asp?plant_id=685",
      },
    ],
  },
  84: {
    gardenImages: [
      {
        image: "/IMG_1524.jpg",
      },
    ],
    googleImages: [
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/41WJ-wC8oZL._SX466_.jpg",
        imageLink:
          "https://www.amazon.com/Purple-Smoketree-Cotinus-Coggygria-Established/dp/B01MTLUD3H",
      },
      {
        image:
          "https://www.botanicaplantnursery.co.uk/user/products/large/Cotinus%20coggygria%20Royal%20Purple.JPG",
        imageLink:
          "https://www.botanicaplantnursery.co.uk/cotinus-coggygria-royal-purple-4098-p.html",
      },
      {
        image:
          "http://www.greenscapesmadison.com/wp-content/uploads/2016/07/royal-purple-smokebush-600x441.jpg",
        imageLink:
          "http://www.greenscapesmadison.com/services/landscape-build-design/softscapes/products/cotinus-coggygria-royal-purple/",
      },
      {
        image:
          "https://p7011128.vo.llnwd.net/e1/wp-content/uploads/plants/originals/13673.jpg",
        imageLink:
          "https://www.monrovia.com/plant-catalog/plants/941/royal-purple-smoke-tree/",
      },
    ],
  },
  85: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/20/00/01/06/pl2000010643.jpg?width=940&height=940",
        imageLink:
          "https://www.crocus.co.uk/plants/_/echinops-bannaticus-taplow-blue/classid.2000010643/",
      },
      {
        image:
          "https://staging-claire-austin-hardy-plants.s3.amazonaws.com/products/1611/product/mpp_echinops-taplow1.jpg?1403042179",
        imageLink:
          "https://www.claireaustin-hardyplants.co.uk/products/echinops-bannaticus-taplow-blue",
      },
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/81D0cWj2xkL._SX355_.jpg",
        imageLink:
          "https://www.amazon.co.uk/Echinops-bannaticus-Taplow-Blue-Thistle-x/dp/B06XXZWSMK",
      },
      {
        image:
          "http://apps.rhs.org.uk/plantselectorimages/detail/WSY0035550_4408.jpg",
        imageLink:
          "https://www.rhs.org.uk/Plants/59261/Echinops-bannaticus-Taplow-Blue/Details",
      },
    ],
  },
  86: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://wimastergardener.org/files/2015/12/Tricyrtis-garden1.jpg",
        imageLink:
          "https://wimastergardener.org/article/hairy-toad-lily-tricyrtis-hirta/",
      },
      {
        image:
          "http://www.vanberkumnursery.com/wp-content/uploads/2017/02/tricyrtis-hirta.jpg",
        imageLink:
          "http://www.vanberkumnursery.com/plant/tricyrtis-hirta-miyazaki/",
      },
      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/9/99/Tricyrtis_hirta_-_blossom_top_%28aka%29.jpg",
        imageLink:
          "https://en.wikipedia.org/wiki/File:Tricyrtis_hirta_-_blossom_top_(aka).jpg",
      },
      {
        image: "https://paramountnursery.ca/wp-content/uploads/2019/04/th.jpg",
        imageLink:
          "https://paramountnursery.ca/product/tricyrtis-hirta-japanese-toad-lily/",
      },
    ],
  },
  87: {
    gardenImages: [
      {
        image: "/IMG_1522.jpg",
      },
    ],
    googleImages: [
      {
        image:
          "https://staging-claire-austin-hardy-plants.s3.amazonaws.com/products/1223/product/mpp_lychnis-coronaria.jpg?1403041293",
        imageLink:
          "https://www.claireaustin-hardyplants.co.uk/products/lychnis-coronaria",
      },
      {
        image:
          "https://www.coblands.co.uk/userfiles/product_image/.main/5704ee16b5a52-lychnis-coronaria.jpg",
        imageLink:
          "https://www.coblands.co.uk/products/2056-lychnis-coronaria-2l",
      },
      {
        image:
          "https://i.etsystatic.com/12311970/r/il/cd3108/988377893/il_794xN.988377893_q45n.jpg",
        imageLink:
          "https://www.etsy.com/listing/286236073/rose-campion-lychnis-coronaria-flower",
      },
      {
        image:
          "http://apps.rhs.org.uk/plantselectorimages/detail/WSYD0000859_3417.jpg",
        imageLink:
          "https://www.rhs.org.uk/plants/10602/i-lychnis-coronaria-i/details",
      },
    ],
  },
  88: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://apps.rhs.org.uk/plantselectorimages/detail/RHS_RHS-0004688_10723.JPG",
        imageLink:
          "https://www.rhs.org.uk/Plants/176462/i-Buddleja-davidii-i-Font-Face-times-New-Roman-Adonis-Blue-FONT-Adokeep-sup-(PBR)-sup/Details",
      },
      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/0/0f/Buddleja_davidii_%27Adonis_Blue%27.jpg",
        imageLink:
          "https://en.wikipedia.org/wiki/Buddleja_davidii_%27Adokeep%27_%3D_Adonis_Blue",
      },
      {
        image: "https://fms.jacqit.nl/pla/box/budadon_2018.jpg",
        imageLink:
          "https://www.plantipp.eu/en/Plants/buddleja-davidii-adonis-blue-adokeeppbr-2/",
      },
      {
        image:
          "https://www.plantsgaloreonline.co.uk/images/products/large/1711_500_011634_BUDABLUE_20080716113913.jpg",
        imageLink:
          "https://www.plantsgaloreonline.co.uk/plants/shrubs/shrubs-a--d/buddleia-davidii-adonis-blue-buddleja-butterfly-bush.html",
      },
      {
        image: "https://fms.jacqit.nl/pla/box/budadon_2012.jpg",
        imageLink:
          "https://www.plantipp.eu/de/pflanzen/buddleja-davidii-adonis-blue-adokeeppbr-2/",
      },
      {
        image:
          "https://www.gardens4you.eu/media/catalog/product/cache/10/image/500x/9df78eab33525d08d6e5fb8d27136e95/F/D/FD11900WH_3.jpg",
        imageLink:
          "https://www.gardens4you.eu/buddleja-davidii-adonis-blue-eu-en.html",
      },
    ],
  },
  89: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://cdn11.bigcommerce.com/s-90ad9/images/stencil/1280x1280/products/2074/3387/Cornus-kousa-Chinese-Dogwood__99869.1518106168.jpg?c=2&imbypass=on",
        imageLink:
          "https://kiginursery.com/deciduous-trees/cornus-kousa-china-girl-white-flower-japanese-dogwood/",
      },
      {
        image:
          "https://www.ornamental-trees.co.uk/images/cornus-kousa-china-girl-tree-p296-1604_medium.jpg",
        imageLink:
          "https://www.ornamental-trees.co.uk/cornus-kousa-china-girl-tree-p296",
      },
      {
        image:
          "http://www.griffinsgardencentre.ie/images/stories/virtuemart/product/Cornus_Kousa_Chi_4fdad23f77956.jpg",
        imageLink:
          "http://www.griffinsgardencentre.ie/garden/cornus-kousa-china-girl",
      },
      {
        image:
          "https://www.pracbrown.co.uk/wp-content/uploads/2016/03/Cornus-kousa-chinensis-150-200-250-300-3-709x921.jpg",
        imageLink:
          "https://www.pracbrown.co.uk/product/cornus-kousa-china-girl-dogwood-china-girl/",
      },
      {
        image:
          "https://d6p0gevo8s9lm.cloudfront.net/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/c/o/cornus-kousa-china-girl_1.jpg",
        imageLink:
          "https://www.gardeningexpress.co.uk/cornus-kousa-china-girl-chinese-dogwood-80-100cm",
      },
      {
        image:
          "https://clarenbridgegardencentre.ie/wp-content/uploads/2017/06/china-girl2.jpg",
        imageLink:
          "https://clarenbridgegardencentre.ie/online-garden-shop/trees-page-6/cornus-kousa-china-girl/",
      },
      {
        image:
          "https://d6p0gevo8s9lm.cloudfront.net/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/c/o/cornus-kousa-china-girl-750x750_1.jpg",
        imageLink:
          "https://www.gardeningexpress.co.uk/cornus-kousa-china-girl-chinese-dogwood-80-100cm",
      },
      {
        image:
          "http://web03.bruns.de/static/images/info/1200Wx1200H/Cornus_kousa_China_Girl_HRM_3243.jpeg",
        imageLink:
          "http://web03.bruns.de/bruns/en/EUR///CORNUS-kousa-%27China-Girl%27/p/904",
      },
    ],
  },
  90: {
    gardenImages: [],
    googleImages: [],
  },
  91: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://s3.amazonaws.com/finegardening.s3.tauntoncloud.com/app/uploads/2018/01/23224311/ceratostigmaplumbaginoides_mg_1_lg_0-main.jpg",
        imageLink:
          "https://www.finegardening.com/plant/ceratostigma-plumbaginoides",
      },
      {
        image:
          "https://davisla6.files.wordpress.com/2015/08/ceratostigma-plumbaginoides.jpg",
        imageLink:
          "https://davisla.wordpress.com/2015/08/20/ceratostigma-plumbaginoides/",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1537/5553/products/08937_1024x1024.jpg?v=1518032672",
        imageLink:
          "https://www.harrisseeds.com/products/08937-ceratostigma-plumbaginoides",
      },
      {
        image:
          "https://p7011128.vo.llnwd.net/e1/wp-content/uploads/plants/originals/8652.jpg",
        imageLink:
          "https://www.monrovia.com/plant-catalog/plants/2486/dwarf-plumbago/",
      },
      {
        image:
          "https://pfaf.org/Admin/PlantImages/CeratostigmaPlumbaginoides2.jpg",
        imageLink:
          "https://pfaf.org/user/Plant.aspx?LatinName=Ceratostigma%20plumbaginoides",
      },
      {
        image:
          "https://www.santarosagardens.com/v/vspfiles/photos/CER-PLU-2.jpg",
        imageLink:
          "https://www.santarosagardens.com/Ceratostigma-p/cer-plu.htm",
      },
    ],
  },
  92: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/20/00/01/35/pl2000013597.jpg?width=940&height=940",
        imageLink:
          "https://www.crocus.co.uk/plants/_/campanula-lactiflora-loddon-anna/classid.2000013597/",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Campanula_lactiflora_Loddon_Anna_3_nbrcg_1024x1024.jpg?v=1452861823",
        imageLink:
          "https://www.ballyrobertgardens.com/products/campanula-lactiflora-loddon-anna",
      },
      {
        image:
          "https://dorsetperennials.co.uk/wp-content/uploads/2014/02/Campanula-lactiflora-Loddon-Anna.jpg",
        imageLink:
          "https://dorsetperennials.co.uk/product/campanula-lactiflora-loddon-anna/",
      },
      {
        image:
          "https://staging-claire-austin-hardy-plants.s3.amazonaws.com/products/1063/product/mpp_campanula-loddon-anna.jpg?1403040937",
        imageLink:
          "https://www.claireaustin-hardyplants.co.uk/products/campanula-lactiflora-loddon-anna",
      },
      {
        image:
          "https://www.gardencentrekoeman.co.uk/db/products/1479311227Campanula_lactiflora_Loddon_Anna.jpg",
        imageLink:
          "https://www.gardencentrekoeman.co.uk/plants/campanula/milky-bellflower-loddon-anna.html",
      },
      {
        image:
          "http://cdn.shopify.com/s/files/1/1069/2032/products/Campanula_lactiflora_Loddon_Anna_3_nbrcg_grande.jpg?v=1452861823",
        imageLink:
          "https://www.ballyrobertgardens.com/products/campanula-lactiflora-loddon-anna",
      },
      {
        image: "https://s3.eu-west-2.amazonaws.com/jparkers/1000/1017448_2.jpg",
        imageLink:
          "https://www.jparkers.co.uk/campanula-lactiflora-loddon-anna-powermodule-1017448c",
      },
    ],
  },
  93: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/A1aWSHr3-YL._SL1500_.jpg",
        imageLink:
          "https://www.amazon.com/Monkshood-Aconitum-napellus-Medicinal-Collector/dp/B071HCKZ6H",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Aconitum_napellus_2_nbcrg_wi_1024x1024.jpg?v=1449680290",
        imageLink:
          "https://www.ballyrobertgardens.com/products/aconitum-napellus",
      },
      {
        image:
          "https://www.penlanperennials.co.uk/wp-content/uploads/2015/11/Aconitum_napellus_JPG1a.jpg",
        imageLink:
          "https://www.penlanperennials.co.uk/plant/shade-and-woodland-plants/aconitum-napellus/",
      },
      {
        image:
          "https://d6p0gevo8s9lm.cloudfront.net/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/A/B/AB79A7437CB4A5D4B3E4733EA9628BC6.jpg",
        imageLink:
          "https://www.gardeningexpress.co.uk/p15004-aconitum-napellus",
      },
      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/2/2a/Aconitum_napellus_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-151.jpg",
        imageLink:
          "https://commons.wikimedia.org/wiki/File:Aconitum_napellus_-_K%C3%B6hler%E2%80%93s_Medizinal-Pflanzen-151.jpg",
      },
      {
        image:
          "https://weberseeds.nl/eshop/images/product_images/original_images/aconitum-napellus.jpg",
        imageLink:
          "https://weberseeds.nl/eshop/en/Seeds/Seeds-A-Z/Aconitum-napellus-True-Monkshood::5.html",
      },
      {
        image:
          "https://images-na.ssl-images-amazon.com/images/I/81ofnZXeZJL._SX425_.jpg",
        imageLink:
          "https://www.amazon.com/Monkshood-Aconitum-Napellus-worlds-Poisonous/dp/B00VEFL3UG",
      },
      {
        image: "https://i.ebayimg.com/images/g/FDYAAOSwe51Z5iK5/s-l300.jpg",
        imageLink:
          "https://www.ebay.com/itm/MONKS-HOOD-Wolfs-Bane-Aconitum-Napellus-Perennial-Blue-Purple-Monkshood-20-Seed-/172932564456",
      },
      {
        image:
          "https://previews.123rf.com/images/silviacrisman/silviacrisman1508/silviacrisman150800024/44160996-monks-hood-aconitum-napellus-aka-aconite-or-wolfsbane-fuzi-monks-blood-flower.jpg",
        imageLink:
          "https://www.123rf.com/photo_44160996_monks-hood-aconitum-napellus-aka-aconite-or-wolfsbane-fuzi-monks-blood-flower.html",
      },
    ],
  },
  94: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://d6p0gevo8s9lm.cloudfront.net/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/v/i/vinca-atropurpurea1.jpg",
        imageLink:
          "https://www.gardeningexpress.co.uk/vinca-minor-atropurpurea-purple-evergreen-periwinkle",
      },
      {
        image:
          "https://www.midwestgroundcovers.com/_ccLib/image/plants/DETA2-230.jpg",
        imageLink:
          "https://www.midwestgroundcovers.com/plant/Vinca-minor-Atropurpurea",
      },
      {
        image:
          "http://apps.rhs.org.uk/plantselectorimages/detail/RHS_WSYD0014397_2022.JPG",
        imageLink:
          "https://www.rhs.org.uk/plants/96889/Vinca-minor-Atropurpurea/Details",
      },
      {
        image:
          "http://www.vanberkumnursery.com/wp-content/uploads/2016/01/Vinca-minor-Lattanzio-Landscapes.jpg",
        imageLink:
          "http://www.vanberkumnursery.com/plant/vinca-minor-atropurpurea/",
      },
      {
        image:
          "https://www.gardens4you.ie/media/catalog/product/cache/9/image/500x/9df78eab33525d08d6e5fb8d27136e95/F/D/FD16460WH_3.jpg",
        imageLink:
          "https://www.gardens4you.ie/vinca-minor-atropurpurea-ie-en.html",
      },
      {
        image:
          "http://www.flowermedia.com/static2/preview2/stock-photo-vinca-minor-atropurpurea--purpleflowered-periwinkle-102052-10739.jpg",
        imageLink:
          "https://www.flowermedia.com/stock-photo/vinca-minor-atropurpurea-purpleflowered-periwinkle-102052-10739.html",
      },
      {
        image:
          "https://plants.oaklandnursery.com/Content/Images/Photos/F294-05.jpg",
        imageLink:
          "https://plants.oaklandnursery.com/12130001/Plant/4213/Burgundy_Periwinkle",
      },
      {
        image:
          "http://www.pcgroundcovers.com/images/products/preview/vinminatrbrw.jpg",
        imageLink:
          "http://www.pcgroundcovers.com/Vinca-Periwinkle-Myrtle/Purple-Flowered-Vinca-Vinca-minor-atropurpurea-Bare-Root-100-for-48.00/",
      },
      {
        image:
          "https://www.florablom.com/media/catalog/product/cache/4/image/9df78eab33525d08d6e5fb8d27136e95/1/4/1432204047vinca_minor___atropurpurea___1/purple-periwinkle-atropurpurea-(vinca-minor).jpg",
        imageLink:
          "https://www.florablom.com/en/purple-periwinkle-atropurpurea-vinca-minor/",
      },
    ],
  },
  95: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Iberis_sempervirens_1_1024x1024.jpg?v=1455114885",
        imageLink:
          "https://www.ballyrobertgardens.com/products/iberis-sempervirens",
      },
      {
        image:
          "https://www.highcountrygardens.com/media/catalog/product/i/b/iberis-sempervirens-purity-dwarf-candytuft-59555-3.jpg?width=700&height=700&canvas=700:700&quality=80&bg-color=255,255,255&fit=bounds",
        imageLink:
          "https://www.highcountrygardens.com/perennial-plants/unique-plants/iberis-sempervirens-purity",
      },
      {
        image:
          "https://i.etsystatic.com/8204508/r/il/2424fd/884952067/il_794xN.884952067_jdkg.jpg",
        imageLink:
          "https://www.etsy.com/listing/259689605/iberis-sempervirens-purity-evergreen",
      },
      {
        image:
          "https://d6p0gevo8s9lm.cloudfront.net/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/i/b/iberis-snowcone-750x750.jpg",
        imageLink:
          "https://www.gardeningexpress.co.uk/iberis-sempervirens-snowcone-candytuft",
      },
      {
        image:
          "https://cdn.mr-fothergills.co.uk/product-images/op/z/25734z.jpg",
        imageLink:
          "https://www.mr-fothergills.co.uk/Flower-Seed/Candytuft-Iberis-sempervirens-Seeds.html",
      },
      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/2/2e/Iberis_sempervirens_002.JPG",
        imageLink:
          "https://commons.wikimedia.org/wiki/File:Iberis_sempervirens_002.JPG",
      },
    ],
  },
  96: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://p7011128.vo.llnwd.net/e1/wp-content/uploads/plants/originals/3852.jpg",
        imageLink:
          "https://www.monrovia.com/plant-catalog/plants/1914/karl-rosenfield-double-peony/",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Paeonia_lactiflora_Karl_Rosenfield_2_1024x1024.jpg?v=1515695000",
        imageLink:
          "https://www.ballyrobertgardens.com/products/paeonia-lactiflora-karl-rosenfield",
      },
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/00/00/00/32/pl0000003298.jpg?width=940&height=940",
        imageLink:
          "https://www.crocus.co.uk/plants/_/paeonia-lactiflora-karl-rosenfield/classid.3298/",
      },
      {
        image:
          "https://apps.rhs.org.uk/plantselectorimages/detail/IMG_9479_Paeonia_lactiflora_Karl_Rosenfield_2012.1253_A_8671.JPG",
        imageLink:
          "https://www.rhs.org.uk/Plants/93628/Paeonia-lactiflora-Karl-Rosenfield/Details",
      },
      {
        image:
          "http://www.perennials.com/watermark.php?path=perennials/1-407-160.jpg&watermark=images/watermark_heritage.png&xpos=.88&ypos=.95",
        imageLink:
          "http://www.perennials.com/plants/paeonia-lactiflora-karl-rosenfield.html",
      },
      {
        image:
          "https://lathamsnursery.com/wp-content/uploads/2015/07/Peony-Karl-Rosenfield-bloom.jpg",
        imageLink:
          "https://lathamsnursery.com/product/peony-karl-rosenfield-2g-paeonia-lactiflora-karl-rosenfield/",
      },
    ],
  },
  97: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "http://cdn.shopify.com/s/files/1/1527/8799/products/Geranium-Azure-Rush-PP-22684.i-2988.s-65676.r-1_1151f73b-fdde-4bb2-8cf7-2569d047e32f_grande.jpg?v=1557945228",
        imageLink:
          "https://www.plantdelights.com/collections/plants-that-start-with-g/products/geranium-azure-rush-pp-22684",
      },
      {
        image:
          "https://www.geraniumrozanne.com/wp-content/uploads/2016/12/Geranium_AzureRush_fp.jpg",
        imageLink:
          "https://www.geraniumrozanne.com/product/geranium-azure-rush/",
      },
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Geranium_Azure_Rush_9_1024x1024.jpg?v=1481289166",
        imageLink:
          "https://www.ballyrobertgardens.com/products/geranium-azure-rush",
      },
      {
        image:
          "http://www.musthaveperennials.com/wp-content/uploads/2017/03/Geranium_Rozanne_fp_300x300.jpg",
        imageLink:
          "http://www.musthaveperennials.com/geranium-rozanne-azure-rush-blushing-turtle/",
      },
      {
        image:
          "http://russellwholesale.com/ZenCart/images/Geranium%20Azure%20Rush.jpg",
        imageLink:
          "http://russellwholesale.com/ZenCart/index.php?main_page=product_info&products_id=2957",
      },
      {
        image:
          "https://dorsetperennials.co.uk/wp-content/uploads/2014/09/Geranium-Azure-Rush.jpg",
        imageLink:
          "https://dorsetperennials.co.uk/product/geranium-azure-rush/",
      },
      {
        image:
          "https://staging-claire-austin-hardy-plants.s3.amazonaws.com/products/1660/product/mpp_geranium-azure-blue2.jpg?1403042299",
        imageLink:
          "https://www.claireaustin-hardyplants.co.uk/products/geranium-azure-rush",
      },
    ],
  },
  98: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://cdn.webvanta.com/000000/51/74/sm/uploads/plant/1534076238-5dd045d8014c93855/botanikfoto-549071-LOptimized.jpg",
        imageLink:
          "https://www.gardenia.net/plant/imperata-cylindrica-red-baron-japanese-blood-grass",
      },
      {
        image:
          "https://www.gardens4you.eu/media/catalog/product/cache/10/image/500x/9df78eab33525d08d6e5fb8d27136e95/F/D/FD17616WH_5.jpg",
        imageLink:
          "https://www.gardens4you.eu/imperata-cylindrica-red-baron-eu-en.html",
      },
      {
        image:
          "https://shop.florando.de/bilder/produkte/gross/Imperata-cylindrica-var-koenigii-Red-Baron-Blutgras.jpg",
        imageLink:
          "https://shop.florando.de/Imperata-cylindrica-var-koenigii-Red-Baron-Blutgras",
      },
      {
        image:
          "https://d6p0gevo8s9lm.cloudfront.net/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/1/D/1D148B3A52DB64959EB21267FC371503.jpg",
        imageLink:
          "https://www.gardeningexpress.co.uk/g10578-imperata-cylindrica-red-baron-pack-of-three-japanese-blood-grasses",
      },
    ],
  },
  99: {
    gardenImages: [],
    googleImages: [
      {
        image:
          "https://cdn.shopify.com/s/files/1/1069/2032/products/Ajuga_reptans_Atropurpurea_2_nbrcg_wi_1024x1024.jpg?v=1532684724",
        imageLink:
          "https://www.ballyrobertgardens.com/products/ajuga-reptans-atropurpurea",
      },
      {
        image:
          "http://www.flowermedia.com/static2/preview2/stock-photo-ajuga-reptans-atropurpurea--dark-purple-bugle-111886-21195.jpg",
        imageLink:
          "https://www.flowermedia.com/stock-photo/ajuga-reptans-atropurpurea-dark-purple-bugle-111886-21195.html",
      },
      {
        image:
          "https://upload.wikimedia.org/wikipedia/commons/6/66/Ajuga_reptans_atropurpurea_01_ies.jpg",
        imageLink:
          "https://commons.wikimedia.org/wiki/File:Ajuga_reptans_atropurpurea_01_ies.jpg",
      },
      {
        image:
          "http://www.flowermedia.com/static2/preview2/stock-photo-ajuga-reptans-atropurpurea--dark-purple-bugle-108865-17859.jpg",
        imageLink:
          "https://www.flowermedia.com/stock-photo/ajuga-reptans-atropurpurea-dark-purple-bugle-108865-17859.html",
      },
      {
        image:
          "https://img.crocdn.co.uk/images/products2/pl/00/00/00/02/pl0000000218_card3_lg.jpg",
        imageLink:
          "https://www.crocus.co.uk/plants/_/ajuga-reptans-atropurpurea/classid.218/",
      },
      {
        image:
          "https://cdn.webshopapp.com/shops/22115/files/6567547/bloemen-flowers-ajuga-reptans-atropurpurea.jpg",
        imageLink:
          "https://www.palmaverde.nl/en/ajuga-reptans-atropurpurea.html",
      },
    ],
  },
};
